import {
  OrganizationalUnitDTO,
  MasterDataDTO,
  UserDTO,
  DivisionDTO,
  Link,
  DocumentClassDTO,
  DossierDTO,
  DocumentDTO,
  FileDetailsDTO,
  LinkedActionsDTO,
  TaskDTO,
  ProfileDTO,
  IObjectDTO,
  ChildOfProjectDTO,
  ProcedureDTO,
  InboxDTO,
  FavouriteProjectDTO,
  ProcurementCommitteeDTO,
  TenderingPhaseDTO,
  BaseObjectDTO,
  PersonDTO,
  BaseEntityDTO,
  DocumentVersionDTO,
  IChildOfDivision,
  TenderV2DTO,
  ActionDTO, AttributeDTO, SearchSettingDTO, SearchSettingFilterDTO, ActionExecutionRequestDTO, CircuitConfigDTO, PropertyDTO, LinkDTO
} from './plyca-dtos';
import { ServiceLocator } from '../ServiceLocator';
import { HelpService } from '../components/common/help/help.service';
import { switchMap } from 'rxjs/operators';

// ProjectEntityDTO
export interface ProjectEntityDTO extends ProcurementProjectDTO {
  contractFolderId: string;
  type: MasterDataDTO;
  startDate: Date;
  organizationalUnit: OrganizationalUnitDTO;
  opcProcedure: boolean;
  title: string;
  favourite: FavouriteProjectDTO;
  // DivisionDTO
  identifier: string;
  children: DivisionDTO[];
  name: string;
  parent: DivisionDTO;
  phase: MasterDataDTO;
  procedure: MasterDataDTO;
  usuid: string;
  project: ProjectEntityDTO;
  userAllowedForSupport: boolean;
  application: string;
}

export class ProjectRelationDTO {
  relation: MasterDataDTO; // TIPO_RELACION
  relationsAsPrimary: ProjectEntityDTO[];
  relationsAsSecundary: ProjectEntityDTO[];
}

export class ProjectStatusDTO {
  state: MasterDataDTO; // EXPESTADO
  phase: MasterDataDTO; // EXPFASE
  situation: DossierSituation;
  filingState: FilingStateType; // SITARCHIVADO
}

export enum DossierSituation {
  Normal = 'Normal',
  Appealed = 'Appealed',
  Discrepancy = 'Discrepancy',
  Cancelled = 'Cancelled',
  Extinguished = 'Extinguished',
  Support = 'Support',
  Draft = 'Draft'
}

export enum FilingStateType {
  NotFiled = '0',
  Pending = '1',
  Deleted = '2'
}

///////////////////////////////////////////
// DTOs asociados a la lógica de validaciones
///////////////////////////////////////////


export class ValidationResultDTO {
  result: ResultTypeDTO;
  errors: ValidationExecutionDTO[];

  constructor(result?: ResultTypeDTO, errors?: ValidationExecutionDTO[]) {
    this.result = result;
    this.errors = errors;
  }
}

export enum ResultTypeDTO {
  OK = 'OK',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  EXCEPTION = 'EXCEPTION',
  LOADING = 'LOADING' // valor de utilidad para el interface
}

export function getResultTypeDTOLevel(type: ResultTypeDTO): number {
  let level: number;
  switch (type) {
    case ResultTypeDTO.FATAL: {
      level = 3;
      break;
    }
    case ResultTypeDTO.EXCEPTION:
    case ResultTypeDTO.ERROR: {
      level = 2;
      break;
    }
    case ResultTypeDTO.WARNING: {
      level = 1;
      break;
    }
    default: {
      level = 0;
      break;
    }
  }
  return level;
}

export class ValidationDTO {
  identifier: string;
  description: string;
  enabled: boolean;
  severity: string;
  execution: ValidationExecutionDTO;
  childrenValidations: ValidationDTO[];

  type: string; // objeto asociado???
  defaultValidation: boolean;
  path: string;
  validationExecutor: string;
  transformationProperty: string;
  validation: string;
}

/**
 * Clase que encapsula una respuesta de validacion en un error con las
 * mismas propiedades que al invocar por HTTP y devolver un error de validacion
 */
export class ValidationResultDTOError extends Error {

  status = 400;
  error: ValidationResultDTO;

  constructor(public validationResult: ValidationResultDTO) {
    super();
    this.error = validationResult;
  }

}

export class ValidationExecutionDTO {
  result: string;
  validationCode: string;
  message: string;
  jsonPath: string;
}

/**
 * Clase con la propiedad context de los IObjetcDTO del API
 */
export class ContextDTO {
  context?: ObjectContextDTO;
}

/**
 * Clase ContextDTO del API
 */
export class ObjectContextDTO {
  name: string;
  secureContext: boolean;
  identifier: string;
  configurations: any;
  severityLevel: ResultTypeDTO;
}

export class BaseDataDTO {
  name: string;
  description: string;
  type: DataTypeDTO;
  value: any;
  format: string;
}

export class WorkDataDTO extends BaseDataDTO {
  json: string;
  modified: boolean;
}

//////////////////////////////////////////////////
// DTOs asociados a la gestion de configuraciones
//////////////////////////////////////////////////
export class ConfigurationDTO {
  identifier: string;
  links: Link[];
  parent: any;
  children: ConfigurationDTO[];
  icon: string;
  name: string;
  description: string;
  items: ConfigurationItemDTO[];
  enabled: boolean;
}

export class ConfigurationItemDTO {
  identifier: string;
  type: string;
  description: string;
  date: Date;
  dateModify: Date;
  refIdentifier: string;
  configurationGroupDTO: any;
  application: ApplicationItemConfigurationDTO;
  entity: EntityItemConfigurationDTO;
}

export class ApplicationItemConfigurationDTO {
  // referencia a la propiedad si type === PROPERTY
  property: PropertyDTO;
  // referencia a la propiedad si type === ATTRIBUTE
  attribute: AttributeDTO;
  // type == TRANSLATION
  translationTable: TranslationTableDTO;
  linkDTO: LinkDTO;
  // referencia a la propiedad si type === WS_DEFINITION
  wsDefinition: WSDefinitionDTO
}

export class EntityItemConfigurationDTO {
  // type == ENTITY_ATTRIBUTE
  attribute: AttributeDTO;
  // type == CERTIFICATE
  certificate: CertificateInformation;
}

export class TranslationTableDTO {
  identifier: string;
  internalLevels: number;
  externalLevels: number;
}


export class CertificateInformation {
  certificateId: number;
  aliases: Set<string>;
  certificateCN: string;
  certificateSubject: string;
  certificateIssuer: string;
  certificateSerialNumber: string;
}

export class WSDefinitionDTO {
  declaration: string;
  endpoint: string;
  uuid: string;
  serviceType: string;
  listWSDefinitionHandlerDTO: WSDefinitionHandlerDTO[];
  listWSDefinitionParameterDTO: WSDefinitionParameterDTO[];
}


export class WSDefinitionHandlerDTO {
  handler: string;
  handlerType: string;
  pivot: number;
  definition: string;
  position: string;
  listWSAttributeHandlerDTO: WSDefinitionHandlerAttributeDTO[];
}

export class WSDefinitionHandlerAttributeDTO {
  handler: string;
  attributeType: string;
  handlerType: string;
  value: string;
  uuid: string;
}

export class WSDefinitionParameterDTO {
  definition: string;
  name: string;
  value: string;
  uuid: string;
}

///////////////////////////////////////////
// DTOs asociados a documento contable
///////////////////////////////////////////
export class AccountingDocumentDTO {
  identifier: string;
  task: TaskDTO;
  links: Link[];
  typedocument: string;
  amount: number;
  changeExercise: boolean;
  orderNumber: number;
  // dossier: DossierDTO;


  captureNumber: string;
  sign: number;
  startYear: number;
  captureDate: Date;
  dossierNumber: string;
  expenditureDossierNumber: string;
  referenceNumber: string;
  accountingOffice: string;

  operationNumber: string;
  postedDate: Date;
  description: string;
  investmentCode: string;

  expenseOriginArea: MasterDataDTO;
  paymentForm: MasterDataDTO;
  fundsCenter: MasterDataDTO;
  society: MasterDataDTO;
  typePayment: MasterDataDTO;
  contractModificationNIF: string;
  contractModificationNumber: string;
  linkOperation: string;
  indexNumber: string;
  operationNumberGroupCurrent: string;
  operationNumberGroupFuture: string;
  referenceNumberGroupCurrent: string;
  referenceNumberGroupFuture: string;
  assigneeYear: string;
  assigneeNumber: string;
  assigneeIdentifier: string;
  procedureActionDossier: ProcedureActionDossierDTO;

  accountingDossierNumber: string;
  expenditureDate: Date;
  obligationRecognitionDate: Date;

  award: AwardDTO;
  interested: CompanyDocDTO;
  assignee: CompanyDocDTO;
  beneficiary: CompanyDocDTO;

  beneficiaryYear: string;
  beneficiaryNumber: string
  beneficiaryIdentifier: string;


  documentClass: DocumentClassDTO;
  division: DivisionDTO;
  document: DocumentDTO;
  expenditurePhases: Array<ExpenditurePhaseDTO>;
  expensePhases: ExpensePhaseDTO[];
  budget: ExpenseBudgetDTO;
  // ExpenseDocumentTypeDTO expenseDocumentType;// GG_TIPO_DOCUMENTO
  // ExpenseDocumentDefinitionDTO expenseDocumentDefinition;// GG_DOCUMENTO
  // Collection<ExpenditurePhaseDTO> expenditurePhases;
  // ExpenseAmountDTO expenseAmount;
  // List<DiscountDTO> discounts;
  expenseDocumentInvoiceAssociation: ExpenseDocumentInvoiceAssociationDTO[];
  expenseDocumentType: ExpenseDocumentTypeDTO;

  availableActions: LinkedActionsDTO;

  accountingSystemToken: string;

  static patchDTO(dto: AccountingDocumentDTO): AccountingDocumentDTO {
    if (!dto) {
      dto = new AccountingDocumentDTO();
    }
    if (!dto.expenditurePhases) {
      dto.expenditurePhases = [];
    }
    return dto;
  }

  contructor() {
    AccountingDocumentDTO.patchDTO(this);
  }
}

export class ExpenseBudgetDTO {
  totalAmount: number;
  budgetAccountLine: Array<BudgetAccountLineDTO>;
}

export class ExpenseDocumentInvoiceAssociationDTO {
  identifier: string;
  associatedInvoiceDetailLine: InvoiceDetailLineDTO;
  document: any;
  expenseDocument: any;
  associatedInvoice: InvoiceDTO;
  associatedTotalAmount: number;

  static patchDTO(dto: ExpenseDocumentInvoiceAssociationDTO): ExpenseDocumentInvoiceAssociationDTO {
    if (!dto) {
      dto = new ExpenseDocumentInvoiceAssociationDTO();
    }
    return dto;
  }
}

export class BudgetAccountLineInvoiceAssociationDTO {
  identifier: string;
  invoiceDetailLine: InvoiceDetailLineDTO; // MATERIALSOLICITADOID
  invoice: InvoiceDTO;
  budgetAccountLine: BudgetAccountLineDTO;
  totalAmount: number;
  taxType: MasterDataDTO; // Tipo de Impuesto   ID_IMPUESTO
  totalTaxes: number;
  // Retenciones asociadas
  budgetAccountLineInvoiceDiscountAssociates: BudgetAccountLineInvoiceDiscountAssociationDTO[];

  static patchDTO(dto: BudgetAccountLineInvoiceAssociationDTO): BudgetAccountLineInvoiceAssociationDTO {
    if (!dto) {
      dto = new BudgetAccountLineInvoiceAssociationDTO();
    }
    return dto;
  }
}

export class BudgetAccountLineInvoiceDiscountAssociationDTO {
  identifier: string;
  invoiceDetailLine: InvoiceDetailLineDTO; // MATERIALSOLICITADOID
  invoice: InvoiceDTO;
  budgetAccountLine: BudgetAccountLineDTO;
  discountType: MasterDataDTO;
  totalAmount: number;
  taxBaseAmount: number;

  static patchDTO(dto: BudgetAccountLineInvoiceDiscountAssociationDTO): BudgetAccountLineInvoiceDiscountAssociationDTO {
    if (!dto) {
      dto = new BudgetAccountLineInvoiceDiscountAssociationDTO();
    }
    return dto;
  }
}


export class ExpenseManagementLineAmountDTO {
  totalAmount: number;
  currentAmount: number;
  earlyProcessingAmount: number;
  futureAmount: number;
  typeExpense: TypeExpense;
}

export enum TypeExpense {
  UNDEFINED = '',
  CURRENTAMOUNT = 'C',
  FUTUREAMOUNT = 'F',
  CURRENTFUTUREAMOUNT = 'CF',
  EARLYPROCESSINGAMOUNT = 'T'
}

export class ExpensePhaseDTO {
  identifier: string;
  description: String;
  order: number;
}

export enum ExpenseTaskStates {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  CONSULT = 'CONSULT'
}

export class ExpenseManagementLineDTO {
  identifier: string;
  // Fases a las que esta asociado el doc (RD/A/D/O)
  expenditurePhases: Array<ExpenditurePhaseDTO>;
  // Importe desglosado en corriente/futuro/tramitacion anticipado
  expenseAmount: ExpenseManagementLineAmountDTO;
  // Ejercicio del documento
  exerciseYear: number;
  // Signo del documento contable
  sign: number;
  // Tipo de documento contable
  accountingDocumentType: string;
  // Estado del documento en la tarea (CONSULT|PENDING|COMPLETED)
  expenseTaskStatus: ExpenseTaskStates;
  // Marca que indica si un documento es anulable
  reversed: boolean;
  // Marca para indicar si se puede crear un documento partiendo de este (boton +)
  newExpenseDocument: boolean;
  // flag para indicar si es un documento contable
  isExpenseDocument: boolean;
  // Documento contable
  expenseDocument: AccountingDocumentDTO;
  // Flag que indica si el documento esta contabilizado
  postedState: boolean
  // Tipo de documento en gestion documental
  documentClassDTO: DocumentClassDTO;
  // Enlace al documento en la gestion documental
  documentDTO: DocumentDTO;

  CP: string; // ExpenseManagementLineCPDTO (marca para indicar si la linea es de corriente/futuro/tramAnticipada). Se calcula en cliente

  static patchDTO(dto: ExpenseManagementLineDTO): ExpenseManagementLineDTO {
    if (!dto) {
      dto = new ExpenseManagementLineDTO();
    }
    return dto;
  }

  contructor() {
    ExpenseManagementLineDTO.patchDTO(this);
  }
}

export enum ExpenseManagementLineCPDTO {
  TRAMITACIONANTICIPADA = 'TRAMITACIONANTICIPADA',
  CORRIENTE = 'CORRIENTE',
  FUTURO = 'FUTURO'
}


export class ExpenseManagementDTO {
  context?: ObjectContextDTO;
  identifier: string;
  links: Link[];
  listExpenseLine: Array<ExpenseManagementLineDTO>;
  task: TaskDTO;

  static patchDTO(dto: ExpenseManagementDTO): ExpenseManagementDTO {
    if (!dto) {
      dto = new ExpenseManagementDTO();
    }
    if (!dto.listExpenseLine) {
      dto.listExpenseLine = [];
    }
    return dto;
  }

  contructor() {
    ExpenseManagementDTO.patchDTO(this);
  }
}

export class ExpenditurePhaseDTO {
  identifier: string;
  task: TaskDTO;
  description: string;
  // Estas variable no viene del servidor. se utiliza en cliente para totalizar el importe por fase
  totalAmount: number;
  totalPostedAmount: number;
  totalPendingAmount: number;

  currentAmount: number;
  currentPostedAmount: number;
  currentPendingAmount: number;

  earlyProcessingAmount: number;
  earlyProcessingPostedAmount: number;
  earlyProcessingPendingAmount: number;

  futureAmount: number;
  futurePostedAmount: number;
  futurePendingAmount: number;

  static patchDTO(dto: ExpenditurePhaseDTO): ExpenditurePhaseDTO {
    if (!dto) {
      dto = new ExpenditurePhaseDTO();
    }
    dto.totalAmount = 0;
    dto.totalPostedAmount = 0;
    dto.totalPendingAmount = 0;

    dto.currentAmount = 0;
    dto.currentPostedAmount = 0;
    dto.currentPendingAmount = 0;

    dto.earlyProcessingAmount = 0;
    dto.earlyProcessingPostedAmount = 0;
    dto.earlyProcessingPendingAmount = 0;

    dto.futureAmount = 0;
    dto.futurePostedAmount = 0;
    dto.futurePendingAmount = 0;
    return dto;
  }

  contructor() {
    ExpenditurePhaseDTO.patchDTO(this);
  }

}

export class ExpenseDocumentLinkDTO {
  identifier: string;
  links: Link[];
  task: TaskDTO;

  // DATOS DEL PADRE
  exerciseClassification: string; // corriente / futuro
  exerciseChange: boolean; //

  documentClass: DocumentClassDTO;
  sign: number;
  expenseDocumentType: ExpenseDocumentTypeDTO;

  // DATOS DEL HIJO
  childDocumentClass: DocumentClassDTO;
  childSign: number;
  childExpenseDocumentType: ExpenseDocumentTypeDTO; // 300

  classDataTransfer: string;
}

export class ExpenseDocumentTypeDTO {
  description: string;
  documentType: string;
  classification: string;
  documentClass: DocumentClassDTO;
  sign: number;
  multipleSign: number;
}

export class ProcedureActionDossierDTO implements IObjectDTO<string> {
  task: TaskDTO;
  identifier: string;
  typeDossierId: string;
  typeDossierDescription: string;
  actionId: string;
  actionDescription: string;
  procedureId: string;
  procedureDescription: string;
  uuid: string;
}

///////////////////////////////////////////
// DTOs asociados a la ficha de expediente
///////////////////////////////////////////
export class ActionDefinitionDTO implements IObjectDTO<string> {
  identifier: string;
  id: string;
  name: string;
  warningMessage: string;
  icon: string;
  description: string;
  links: Array<Link>;

  enabled: boolean;
  readonly: boolean;
  organismoid: OrganizationalUnitDTO;
  actionClasification: MasterDataDTO;
  actionObjType: MasterDataDTO;
  actionTypeExec: MasterDataDTO;
  parametersDefinition: any;
  parameters: any;

  source: string;
  visibilityDefault = false;
  visibilities: any;

  contentFileTmp: boolean;
  actionUndo: any;
  executableAction: ActionDTO;
  task: TaskDTO;
  constructor() {
    this.parametersDefinition = [];
  }

}

export class ClassifiedActionsDTO {
  classification = 'ff';
  actions: Array<ActionDefinitionDTO>;
  constructor() {
    this.actions = [];
  }
}

export class ActionParameterDefinitionDTO {
  identifier: string;
  description: string;
  editable: boolean;
  jsonField: string;
  required: boolean;
  tooltip: string;
  visible: boolean;
  type: any;

  value: any;
  name: string;
  idSearch: string;
  typeElement: string;
  undoAction: boolean;
  autoSearch: boolean;
  parameters: SearchSettingFilterDTO[];
}



export class SearchActionResultDTO {
  success: boolean;
  description: string;
  objectResult: any;
  error: any; // HttpErrorResponse;
}



export class ActionResultDTO {
  identifier: string;
  file: FileDetailsDTO;
  description: string;
  objectResult: any;
  redirect: ActionRedirectionDTO;
  repeatable: boolean;
  showSuccessMessage: boolean;
  showWarningMessage: boolean;
  returnObjectResult: boolean;
  validationResult: ValidationResultDTO;

  request: ActionExecutionRequestDTO;
}

export class ActionRedirectionDTO {
  contractFolderId: string;
}

///////////////////////////////////////////
// DTOs asociados a la ficha de expediente
///////////////////////////////////////////

export class StatusDTO {
  // Tipo estado
  state: MasterDataDTO;
  situacion: string;
  filingState: string;
}
export class ProcurementProjectStatusDTO {
  state: MasterDataDTO; // EXPEDIENTE.EXPESTADO
  phase: MasterDataDTO; // EXPEDIENTEBASE.EXPFASE
}

export class ProcurementProjectClassificationDTO {
  abbreviated: boolean; // abbreviated
  awardMethod: MasterDataDTO; // forma de adjudicacion
  internalNorm: MasterDataDTO; // norma interna
  typeCode: MasterDataDTO; // Tipo Expediente
  urgencyCode: MasterDataDTO; // ClaseExpte
  subTypeCode: MasterDataDTO; // Modalidad
  complementarySystem: MasterDataDTO; // sistema complementario
  processJustification: string; // Justificación del procedimiento
  processJustificationNegotiated: string; // Justificación del procedimiento negociado.
  contractMinorExclusivity: boolean; // Contrato menor por exclusividad
  expenseCode: boolean; // tipo de tramitación del gasto (tramitación anticipada)
  publishable: boolean; // publicable
  processingMode: MasterDataDTO; // Modo de tramitación
  submissionMethodCode: boolean; // licitacion electronica
  procurementCommittee: boolean; // Indica si se realizará mesa de contratación (FICHAEXPTE.MESACONTR)
  harmonizedRegulation: boolean; // Indica si el expediente es de regulación armonizada
  harmonizedRegulationException: boolean; // Permite excepcionar la regulación armonizada
  auction: boolean; // adjudicación por subasta
  fundedPRTR: boolean; // Financiado por el PRTR
  initiativePRTR: string; // Iniciativa del PRTR


  static patchDTO(
    dto: ProcurementProjectClassificationDTO
  ): ProcurementProjectClassificationDTO {
    if (!dto) {
      dto = new ProcurementProjectClassificationDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    ProcurementProjectClassificationDTO.patchDTO(this);
  }
}

export class BudgetAmountDTO {
  budgetType: MasterDataDTO; // tipo de presupuesto
  taxType: MasterDataDTO; // tipo de impuesto
  totalAmount: number;
  estimatedAmount: number;
  estimatedAmountPrevious: number;
  amountExcludingTaxes: number;
  totalTaxes: number;
  taxRate: string;
  budgetYear: number;
  // garantia
  provisionalGuarantee: boolean;
  provisionalGuaranteeAmount: number;
  provisionalGuaranteePercentage: number;
  finalFinancialGuarantee: boolean;
  finalFinancialGuaranteePercentage: number;
  budgetAccounLine: BudgetAccountLineDTO[];


  static patchDTO(dto: BudgetAmountDTO): BudgetAmountDTO {
    if (!dto) {
      dto = new BudgetAmountDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    BudgetAmountDTO.patchDTO(this);
  }

  constructor(init?: Partial<BudgetAmountDTO>) {
    Object.assign(this, init);
  }
}

export class ProcurementProjectBudgetDTO extends BudgetAmountDTO {
  withoutUnitPrice: boolean;

  constructor(init?: Partial<ProcurementProjectBudgetDTO>) {
    super(init);  // Llama al constructor de la clase padre
    Object.assign(this, init);
  }

  static patchDTO(dto: any): ProcurementProjectBudgetDTO {
    return new ProcurementProjectBudgetDTO(dto);
  }
}



// condiciones de licitacion
export class TenderingTermDTO {
  tenderValidityPeriod: number; // Plazo de Validez de la Oferta: FICHAEXPTE.PLAZOVALIDEZ_OFERTA
  utTenderValidityPeriod: MasterDataDTO; // periodo del plazo de validez de la oferta

  static patchDTO(dto: TenderingTermDTO): TenderingTermDTO {
    if (!dto) {
      dto = new TenderingTermDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    TenderingTermDTO.patchDTO(this);
  }
}

export class PromoterInfoDTO {
  organizationalUnit: OrganizationalUnitDTO;
  user: UserDTO;

  static patchDTO(dto: PromoterInfoDTO): PromoterInfoDTO {
    if (!dto) {
      dto = new PromoterInfoDTO();
    } else {
      dto.user = UserDTO.patchDTO(dto.user);
      // dto.organizationalUnit = OrganizationalUnitDTO.patchDTO (dto.organizationalUnit);
    }
    return dto;
  }

  contructor() {
    PromoterInfoDTO.patchDTO(this);
  }
}

export class BudgetAccountLineDTO {
  year: number;
  exercise: string;
  organic: string;
  functional: string;
  economical: string;
  identifier: number;
  description: string; // Partidas Sector Público: ANUALIDADAPLICACION.DES_ANUALIDAD
  budget: BudgetDTO; // Desglose importes anualidades
  investnmentProject: string; // Proyecto de Investigación: ANUALIDADAPLICACION.PROYINVID
  startYearProject: number; // ANUALIDADAPLICACION.ANNOINICIOPROYECTO
  remittance: string; // Remesa: ANUALIDADAPLICACION.REMESA
  territoryKey: MasterDataDTO; // Clave Territorial
  eligibility: MasterDataDTO; //// Indica si se pueden utilizar fondos europeos en esas aplicacion - proyecto
  projectStartYear: number; // Año Inicio proyecto
  lot: LotDTO; // ANUALIDADAPLICACION.LOTE: Lote de la Anualidad
  nature: MasterDataDTO; // ANUALIDADAPLICACION.NATURALEZA: Naturaleza de la Anualidad
  budgetAccountLineInvoiceAssociates: BudgetAccountLineInvoiceAssociationDTO[]; // Facturas y detalle de facturas asociadas a una partida
  label: string; // Identificador que se utiliza en AYMAD para mostrar en la tabla  PARTIDA_FACTURA;
  fixedAssetNumber: string; // ACTIVOFIJO
  fixedAssetSubNumber: string; // SUBNUMERO
  movementType: string;  // CLASEMOVIMIENTO
}

export class LotBudgetAccountLineDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  context?: ObjectContextDTO;
  year: number;
  organic: string;
  functional: string;
  economical: string;
  budget: BudgetDTO;
}

export class ProjectBreakDownDTO {
  apportioned: boolean; // Indica si el expediente tiene lotes
  lots: Array<ProcurementProjectLotDTO>; // Lotes del expediente
  totalLots: ProcurementProjectLotDTO; // Lote cero del expediente, que contiene la suma de todos los lotes del expediente
  justificationForNo: string;
  justificationForYes: string;
  numLicitableLots: number;
  numContractLots: number;
  tenderAllLots: boolean;

  static patchDTO(dto: ProjectBreakDownDTO): ProjectBreakDownDTO {
    if (!dto) {
      dto = new ProjectBreakDownDTO();
    } else {
      if (!dto.lots) {
        dto.lots = [];
      }
      dto.lots.map(lot => (lot = ProcurementProjectLotDTO.patchDTO(lot)));
      dto.totalLots = ProcurementProjectLotDTO.patchDTO(dto.totalLots);

      // temporal para asegurar que no esta en el array de lotes la referencia al lote 0
      dto.lots = dto.lots.filter(
        lot => lot.identifier !== dto.totalLots.identifier
      );
    }
    return dto;
  }

  contructor() {
    ProjectBreakDownDTO.patchDTO(this);
  }
}

export class ProcurementProjectLotGroupDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  name: string;
  lots: Array<ProcurementProjectLotDTO>;
  groupId: number;
}
export class CriteriaDefinitionDTO implements ChildOfProjectDTO<string> {
  project: ProjectEntityDTO;
  links: Link[];
  identifier: string;
  task: TaskDTO;
  parentAwardCriteria: number;
  name: string;
  descritpion: string;
  awardingCriteriaTypeCode: boolean;
  weight: number;
  normalizedWeigh: number;
  direction: CriteriaDirectionEnum;
  formula: MasterDataDTO;
  satietyThreshold: number;
  satisfactionThreshold: number;
  valuationFactor: number;
  group: string;
  criteriaType: MasterDataDTO;
  lot: ProcurementProjectLotDTO;
}

export class CriteriaFormulaDTO {
  identifier: string;
  task: TaskDTO;
  name: string;
  descritpion: string;
  expression: string;
  preview: string;
  active: boolean;
  editable: boolean;
}

export enum CriteriaDirectionEnum {
  MAXIMIZE = '1',
  MINIMIZE = '-1'
}
export class ContractingSystemDTO {
  originalContractingSystemLotID: ProcurementProjectLotDTO;
  originalContractingSystemID: ProjectEntityDTO;
  // Acuerdos Marco sin padre
  baseContractNoRelated: boolean;
  // Todos los criterios de adjudicación establecidos en el AM
  frameworkAgreementCriteria: boolean;
  // Concreción de Criterios: CRITERIOSADJ_AM
  criteriaConcretion: string;
  // Licitacion Basada en Acuerdo Marco LICITACION_CBAM
  tenderBasedFrameworkAgreement: boolean;
  // Prevista Nueva Licitación Basado en Acuerdo Marco: PREVISTA_LICITACION_CBAM
  plannedTenderBasedFrameworkAgreement: boolean;



  static patchDTO(dto: ContractingSystemDTO): ContractingSystemDTO {
    if (!dto) {
      dto = new ContractingSystemDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    ContractingSystemDTO.patchDTO(this);
  }
}

export class TariffDTO {
  tarrifId: number; // TARIFAS.TARIFAID
  description: string; // TARIFAS.DESCRIPTION
  price: number; // TARIFAS.PRICE
  uuid: string; // TARIFAS.UUID
}

export class SpecialEconomicTermDTO {
  income: boolean; // Ingreso // FICHAEXPTE2.INGRESO
  canon: boolean; // Canon // FICHAEXPTE2.CANON
  price: boolean; // Precio // FICHAEXPTE2.PRECIO
  rate: boolean; // Tarifa // FICHAEXPTE2.TARIFA
  compensation: boolean; // Contraprestación // FICHAEXPTE2.CONTRAPRESTACIÓN

  tariff: Array<TariffDTO>;

  static patchDTO(dto: SpecialEconomicTermDTO): SpecialEconomicTermDTO {
    if (!dto) {
      dto = new SpecialEconomicTermDTO();
    } else {
      if (!dto.tariff) {
        dto.tariff = [];
      }
    }
    return dto;
  }

  contructor() {
    SpecialEconomicTermDTO.patchDTO(this);
  }
}
export class ProcurementProjectLotDTO implements ChildOfProjectDTO<string> {
  project: ProjectEntityDTO;
  links: Link[];
  identifier: string;
  task: TaskDTO;
  lotId: number;
  lotNumber: number;
  state: number;
  completed: number;
  description: string;
  province: MasterDataDTO;
  nut: MasterDataDTO; // NUT: Codigo Territorial
  entity: OrganizationalUnitDTO// Unidad Entidad del lote
  reservedContractType: MasterDataDTO; // Tipo de contrato reservado
  rejectedLot: boolean; // Marca lote desierto
  rejectedDate: Date; // Fecha declaración desierto
  budget: LotBudgetDTO; // Importes del Lote, Importe en Bienes del Lote

  cpvs: Array<CPVDTO>;
  cpas: Array<CPADTO>;

  // Criterios de justificacion de solvencia (sin desglose de lotes en producto)
  criteriaTechnicalFinancial: Array<TechnicalFinancialEvaluationCriteriaDTO>;
  // Clasificación (Grupos, Subgrupos y Categoria)
  classificationCompany: Array<ClassificationSchemaDTO>;
  // Capacidad para Contratar
  abilityContract: Array<AbilityContractDTO>;
  // Formulas de Revisision de Precios
  priceRevision: PriceRevisionDTO;
  // Condiciones de Licitacion
  tenderingTerm: TenderingTermDTO;
  // criterios de adjudicacion
  selectionAwardCriteria: Array<CriteriaDTO>;
  // operador economico
  specialEconomicTerm: SpecialEconomicTermDTO;
  // plazos parciales
  partialPeriod: PartialPeriodDTO;
  // Prevista Nueva Licitación basado en Acuerdo Marco
  tenderBasedFraFrameworkAgreement: boolean;
  // Condiciones Especiales de la Ejecución
  specialExecutionCondition: Array<SpecialExecutionConditionDTO>;
  // Clausulas Sociales : Criterios de Adjudicación
  scAwardCriteria: Array<SocClausesAwardCritDTO>;
  validationResult: ValidationResultDTO;
  context?: ObjectContextDTO;
  parent: ProcurementProjectDTO;
  // Atributos, propiedades, etc.
  auxProperties = {};

  // Tipo de resolución de no Adjudicación: Desierto, Desestimiento o Renuncia
  nonAwardResolutionType: MasterDataDTO;
  // Motivo de resolución de no Adjudicación
  nonAwardResolutionReason: MasterDataDTO;
  // TextoMotivo de resolución de no Adjudicación
  textNonAwardResolutionReason: String;

  static patchDTO(dto: ProcurementProjectLotDTO): ProcurementProjectLotDTO {
    if (!dto) {
      dto = new ProcurementProjectLotDTO();
    } else {
      if (!dto.cpvs) {
        dto.cpvs = [];
      }
      if (!dto.cpas) {
        dto.cpas = [];
      }
      if (!dto.criteriaTechnicalFinancial) {
        dto.criteriaTechnicalFinancial = [];
      }
      if (!dto.classificationCompany) {
        dto.classificationCompany = [];
      }
      if (!dto.abilityContract) {
        dto.abilityContract = [];
      }
      if (!dto.selectionAwardCriteria) {
        dto.selectionAwardCriteria = [];
      }
      if (!dto.specialExecutionCondition) {
        dto.specialExecutionCondition = [];
      }
      dto.budget = LotBudgetDTO.patchDTO(dto.budget);
      dto.priceRevision = PriceRevisionDTO.patchDTO(dto.priceRevision);
      dto.tenderingTerm = TenderingTermDTO.patchDTO(dto.tenderingTerm);
      dto.specialEconomicTerm = SpecialEconomicTermDTO.patchDTO(
        dto.specialEconomicTerm
      );
    }
    return dto;
  }

  contructor() {
    ProcurementProjectLotDTO.patchDTO(this);
  }
}

export class AbilityContractDTO {
  abilityContractId: MasterDataDTO;
  description: string;
  uuid: string;

  static patchDTO(dto: AbilityContractDTO): AbilityContractDTO {
    if (!dto) {
      dto = new AbilityContractDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    AbilityContractDTO.patchDTO(this);
  }
}

export class ProcurementProjectCharacteristicDTO {

  activeConfidentialityPeriod: boolean; // Este campo no existe en base de datos, es un campo ficticio
  confidentialityPeriod: string; // Descripcion del Periodo de Confidencialidad
  specialServices: boolean; //  Servicios Especiales (Anexo IV): FICHAEXPTE1.SERV_ESPECIALES
  formalizationMinorContract: boolean; // Formalización del contrato menor: FICHAEXPTE1.FORMALIZA_MENOR

  //  Características del Expediente
  economicCompensation: boolean; // Compensación Económica: EXPEDIENTE.CECONOMICA
  additionalDisposition: boolean; // Disposición Adic. 9ª: FICHAEXPTE1.DISPOSICIONADIC
  fiftyFourthAdditionalDisposition: boolean; // Disposición Adic. 54ª: FICHAEXPTE1.DISPOSICIONADIC_QCUARTA

  // Asociaciones con instancias del componente Documento Referenciado, utilizadas para especificar la relación de
  // anuncios y publicaciones anteriores relativas al mismo contrato
  // (Anuncio de Información Previa, Anuncio de Licitación, Envío al DOUE, etc.).
  noticeDocumentReference: boolean; // Anuncio de Información Previa:  FICHAEXPTE1.ANUINDICATIVO
  shippingDateDOUE: Date; // Fecha de envío al DOUE:
  publicationDateBOE: Date; // Fecha de publicación en el BOE:
  publicationDateContractingProfile: Date; // Fecha de Publicación en el Perfil del Contratante

  reservedContractType: MasterDataDTO; // Tipo de contrato Reservado
  participantsLimit: boolean; // Limitar el número de participantes
  presentationPhaseConciseIdea: boolean; // Fase de Presentación Idea Concisa

  entity: OrganizationalUnitDTO; // Entidad

  static patchDTO(
    dto: ProcurementProjectCharacteristicDTO
  ): ProcurementProjectCharacteristicDTO {
    if (!dto) {
      dto = new ProcurementProjectCharacteristicDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    ProcurementProjectCharacteristicDTO.patchDTO(this);
  }
}

export class TechnicalFinancialEvaluationCriteriaDTO {
  technicalFinancialEvaluation: MasterDataDTO;
  description: string;
}

export class ClassificationSchemaDTO {
  group: MasterDataDTO;
  subgroup: MasterDataDTO;
  category: MasterDataDTO;
}

export class ContractSpecialConditionsDTO {
  identifier: string;
  idSpecialCondition: MasterDataDTO;
  selected: boolean;
  detail: string;
  tracing: boolean;
  specialCondTracingReportPeriod: SpecialCondTracingReportPeriodDTO;
}

export class SpecialCondTracingReportPeriodDTO {
  tracingReportPeriodMode: number;
  tracingReportPeriod: number;
  utTracingReportPeriod: MasterDataDTO;
}

export class SpecialCondTracingReportDTO {
  specialConditionIds: string[];
  nextDeadline: Date;
  requestDate: Date;
  responseDate: Date;
  valorationAverage: number;
  responseInPeriod: boolean;
  responseDoc: DocumentDTO;
  valorationDoc: DocumentDTO;
}

export class KpiRecordDTO {
  date: Date;
  value: number;
  kpiId: string;
  kpiDescription: string;
  levelId: string;
  levelDescription: string;
}

export class ContractAwardCriteriaDTO {
  idAwardCriteria: MasterDataDTO;
  selected: boolean;
  detail: string;
  typeCriteria: MasterDataDTO;
  weighing: number;
}

export class CPVDTO implements Desglosable {
  listaLotes: ProcurementProjectLotDTO[];

  identifier: string;
  code: string;
  description: string;
  classification: string;
}

export interface Desglosable {
  listaLotes: Array<ProcurementProjectLotDTO>;
}

export class CPADTO {
  identifier: string;
  description: string;
}
export class BudgetDeterminationSystem {
  budgetDeterminationSystem: MasterDataDTO;
}

export class LotBudgetDTO extends BudgetAmountDTO {
  // Pago en metálico y otros bienes
  goodsDescription: string;
  goodsAmount: number;

  // plazos de garantia
  guaranteeTerm: number;
  guaranteeTermUnit: MasterDataDTO;
  justificationNotGuarantee: string;

  // arriendo y canon
  leasePrice: number; // Precio del Arriendo
  leaseCanon: number; // Canon de Arrendamiento
  provisionalPrice: boolean; // Precio provisional
  closedPrice: boolean; // Precio Cerrado

  // baja temeraria
  lowTendersDescription: string;

  // precios unitarios
  unitPrice: Array<UnitPriceDTO>;
  // material solicitado
  requestedMaterial: Array<RequestMaterialDTO>;
  // Sistema de determinación del presupuesto (AHORA NO TIENEN DESGLOSE Y AYMAD SI)
  budgetDeterminationSystems: Array<BudgetDeterminationSystem>;
  // Determinacion Presupuesto por prec. unitarios
  budgetDetermination: boolean;
  // Anualidades desglosadas por lote -- ayumad
  lotBudgetAccountLine: Array<LotBudgetAccountLineDTO>;




  static patchDTO(budget: LotBudgetDTO): LotBudgetDTO {
    if (!budget) {
      budget = new LotBudgetDTO();
    }
    if (!budget.unitPrice) {
      budget.unitPrice = [];
    }
    if (!budget.budgetDeterminationSystems) {
      budget.budgetDeterminationSystems = [];
    }
    if (!budget.requestedMaterial) {
      budget.requestedMaterial = [];
    }
    return budget;
  }

  contructor() {
    LotBudgetDTO.patchDTO(this);
  }
}
export class ProjectRelationTable {
  primaryRelation: ProjectEntityDTO;
  secundaryRelation: ProjectEntityDTO;
  relationType: MasterDataDTO;
}

export class ProcurementProjectDTO {
  project: ProjectEntityDTO;
  links: Link[];
  identifier: string;
  task: TaskDTO;
  availableActions: LinkedActionsDTO;
  // identificador del formulario
  formId: string;
  division: DivisionDTO;

  // base project
  phase: MasterDataDTO;
  type: MasterDataDTO;
  creationDate: Date;
  title: string;
  opcProcedure: boolean;
  name: string;
  contractFolderId: string;
  startDate: Date;
  organizationalUnit: OrganizationalUnitDTO;
  procurementProjectStatus: ProcurementProjectStatusDTO;
  documentClass: DocumentClassDTO;
  status: ProjectStatusDTO;
  // fin base project

  relatedProject: boolean;
  projectRelations: Map<string, ProjectRelationDTO>;
  relationsAsSecondary: ProjectRelationTable;
  listaRelaciones: ProjectRelationTable[];

  // Procurementproject
  reduced: boolean;
  applicableLegislation: MasterDataDTO;
  startYear: number;
  user: UserDTO; // usuario que ha creado el expediente
  abbreviatedTitle: string;
  description: string; // objeto del contrato
  directive24UE: string;
  euDirective: MasterDataDTO;

  // Campos propios de Ayuntamiento
  exp_Subcontratacion_2023: boolean;

  classification: ProcurementProjectClassificationDTO;
  budget: ProcurementProjectBudgetDTO;
  promoterUser: PromoterInfoDTO;
  breakdownLot: ProjectBreakDownDTO;
  contractInformation: ContractInformationDTO;
  worksData: WorksDataDTO;
  //// Expediente padre: AM y Contratos Basados (Acuerdo Marco original o Sistemas Dinámicos de Adquisicion
  contractingSystem: ContractingSystemDTO;
  labelCPV: string;
  ////

  characteristicsContractObject: ProcurementProjectCharacteristicDTO;


  // modelo  que contiene la informacion desglosada
  desglosableInfo: DesglosableInfoDTO;

  // temporal
  tenderRequirements: TenderRequirementsDTO;

  // AM original en el caso de contratos Basados
  procurementProjectAM: ProcurementProjectDTO;

  // para campos personalizables cuyo origen es FichaExpedienteX
  customFields: any;

  ui: any;
  validationResult: ValidationResultDTO;
  context?: ObjectContextDTO;

  static patchDTO(dto: ProcurementProjectDTO): ProcurementProjectDTO {
    if (!dto) {
      dto = new ProcurementProjectDTO();
    } else {
      dto.budget = ProcurementProjectBudgetDTO.patchDTO(dto.budget);
      dto.classification = ProcurementProjectClassificationDTO.patchDTO(
        dto.classification
      );
      dto.promoterUser = PromoterInfoDTO.patchDTO(dto.promoterUser);
      dto.breakdownLot = ProjectBreakDownDTO.patchDTO(dto.breakdownLot);
      dto.tenderRequirements = TenderRequirementsDTO.patchDTO(
        dto.tenderRequirements
      );
      dto.contractInformation = ContractInformationDTO.patchDTO(
        dto.contractInformation
      );
      dto.characteristicsContractObject = ProcurementProjectCharacteristicDTO.patchDTO(
        dto.characteristicsContractObject
      );
      dto.worksData = WorksDataDTO.patchDTO(dto.worksData);
      dto.desglosableInfo = DesglosableInfoDTO.patchDTO(dto.desglosableInfo);

      dto.customFields = CustomFieldDTO.patchDTO(dto.customFields);
    }
    return dto;
  }

  static normalizaDossierId(dossierId: string): string {
    return (dossierId) ? (dossierId.substring(0, 4) + '/' + dossierId.substring(4)) : undefined;
  }

  contructor() {
    ProcurementProjectDTO.patchDTO(this);
  }
}

// export class CustomFieldGroupDTO {
//   identifier: string;
//   name: string;
//   description: string;
//   ambito: Array<string>;
//   customFields: Array<CustomFieldDTO>;

//   static patchDTO(dto: CustomFieldGroupDTO): CustomFieldGroupDTO {
//     if (!dto) {
//       dto = new CustomFieldGroupDTO();
//     } else {
//       dto.customFields = [];
//       dto.ambito = [];
//     }
//     return dto;
//   }
//   constructor() {
//     CustomFieldGroupDTO.patchDTO(this);
//   }
// }
export class ColumnLocationDTO {
  table: string;
  column: string;
}

export class I18nDTO {
  es: string;
  ca: string;
  gl: string;
}
export class CustomFieldOwnerDTO {
  resource: MasterDataDTO;
  extendedDataId: number;
  documentClasses: DocumentClassDTO[];
}
export class CustomFieldDisplayDTO {
  i18nDescription: I18nDTO;
  i18nTooltip: I18nDTO;
  helpTags: string[];
}
export class CustomFieldOriginDTO {
  table: MasterDataDTO;
  listName: string;
  attribute: AttributeDTO;
  search: SearchSettingDTO;
  query: string;
}
export class CustomFieldDestinationDTO {
  attribute: AttributeDTO;
  location: ColumnLocationDTO;
}
export class CustomFieldDTO {
  type: string;
  subType: string;
  format: string;
  enabled: boolean;
  identifier: string;
  name: string;
  description: string;
  task: TaskDTO;
  value: any;
  calculated: boolean;
  owner: CustomFieldOwnerDTO;
  origin: CustomFieldOriginDTO;
  destination: CustomFieldDestinationDTO;
  display: CustomFieldDisplayDTO;


  static patchDTO(dto: CustomFieldDTO): CustomFieldDTO {
    if (!dto) {
      dto = new CustomFieldDTO();
    }
    return dto;
  }
  constructor() {
    CustomFieldDTO.patchDTO(this);
  }
}


export class CriteriaDefDTO {
  identifier: string;
  name: string;
  description: string;
  awardingCriteriaTypeCode: boolean;
  formula: MasterDataDTO;
  direction: string;
  satisfactionThreshold: number;
  satietyThreshold: number;
  valuationFactor: number;
  justification: string;
  /*criteriaType: MasterDataDTO;
  group: string;*/

  task: TaskDTO;

  static patchDTO(dto: CriteriaDefDTO): CriteriaDefDTO {
    if (!dto) {
      dto = new CriteriaDefDTO();
    }
    return dto;
  }
  constructor() {
    CriteriaDefDTO.patchDTO(this);
  }
}

export enum ResourceFileTypeDTO {
  VALIDATION = 'validation',
  VALIDATION_CUSTOMIZATION = 'validation_customization',
  SCREEN = 'screen',
  SCREEN_CUSTOMIZATION = 'screen_customization',
  HELP = 'help',
  SEARCH_CONFIG = 'search_config'
}

export class ResourceFileDTO {
  identifier: string;
  name: string;
  resourceType: any;
  fileType: MasterDataDTO;
  enabled: boolean;
  uploadDate: Date;
  description: string;
  product: boolean;
  file: any;

  task: TaskDTO;

  static patchDTO(dto: ResourceFileDTO): ResourceFileDTO {
    if (!dto) {
      dto = new ResourceFileDTO();
    }
    return dto;
  }
  constructor() {
    ResourceFileDTO.patchDTO(this);
  }
}

export class PartialPeriodDTO {
  existsPartialDelivery: boolean; // Hay plazos parciales
  partialReceptions: boolean; // Recepciones Parciales
  note: String; // Observaciones de los plazos
  partialDeliveries: Array<PartialDeliveriesDTO>; // Fechas de Entregas Parciales
  static patchDTO(dto: PartialPeriodDTO) {
    dto.partialDeliveries = [];
  }
  contructor() {
    PartialPeriodDTO.patchDTO(this);
  }
}

export class PartialDeliveriesDTO {
  partialDeliveryId: number; // Identificador de fecha de entregas parciales
  descriptionDate: String; // Descripción de la fecha de entregas parciales
  deliveryDate: Date; // Fecha de entregas parciales
  uuid: String;
  static patchDTO(dto: PartialDeliveriesDTO) { }
  contructor() {
    PartialDeliveriesDTO.patchDTO(this);
  }
}
export class UnitPriceFilter {
  lot: ProcurementProjectLotDTO;
  parentDoc: TenderV2DTO;
}
export class UnitPriceDTO {
  lot: ProcurementProjectLotDTO;
  identifier: number;
  description: String;
  unitPriceId: number;
  uuid: String;

  // Nuevos campos añadidos que estan en producto pero se utilizan en AYUMAD
  unitPrice: number; // Importe del IVA:  PRESUPMAXGAS.PRESUNITARIO
  taxType: MasterDataDTO; // Tipo de Impuesto: PRESUPMAXGAS.TIPO_IVA
  totalAmount: number; // Importe del Precio Unitario:PRESUPMAXGAS.PRESUNITARIO_CONIVA
  amountExcludingTaxes: number; // Importe sin IVA: PRESUPMAXGAS.PRESUNITARIO_SINIVA
  totalTaxes: number; // Importe del IVA:  PRESUPMAXGAS.CUANTIA_IVA
  awardPriceUnit: String; // Precio de Adjudicación por unidad: PRESUPMAXGAS.PRESUNADJUD
  internalCode: String; // Codigo Interno:  PRESUPMAXGAS.CODIGO_INTERNO
  amount: number; // Cantidad: PRESUPMAXGAS.CANTIDAD
  group: String; // Grupo: PRESUPMAXGAS.GRUPO
  complementaryOne: String;  // Complementario 1: PRESUPMAXGAS.COMPLEMENTARIO1
  complementaryTwo: String; // Complementario 2: PRESUPMAXGAS.COMPLEMENTARIO2
  tenderingPrice: number;   // Precio de Licitación: PRESUPMAXGAS.PRECIO_LICITACION
  lowPercentage: number;    // Porcentaje Baja: PRESUPMAXGAS.PORCENTAJE_BAJA

  static patchDTO(dto: UnitPriceDTO) { }
  contructor() {
    UnitPriceDTO.patchDTO(this);
  }
}


export class UnitPricesFilterDTO {

  description: string;
  code: string;
  group: string;
  filterListaLotes: ProcurementProjectLotDTO[] = [];
  filterSelectedLot: ProcurementProjectLotDTO;
}

export class RequestMaterialDTO {
  identifier: string;
  task: TaskDTO;
  description: string;
  amount: number;
  unitPrice: number;
  totalAmount: number;
  lot: ProcurementProjectLotDTO;
  catalogId: string;
  listaLotes: ProcurementProjectLotDTO[];
  referenceCode: string;

  static patchDTO(dto: RequestMaterialDTO) { }
  contructor() {
    RequestMaterialDTO.patchDTO(this);
  }
}
export class TenderRequestedMaterialDTO {

  identifier: string;
  task: TaskDTO;
  tender: TenderV2DTO;
  uuid: string;
  unitPrice: number;
  supplierReference: string;
  requestedMaterial: RequestMaterialDTO;
  division: any;
  orderNumber: string;
  documentClass: any;

}

export class AwardRequestedMaterialDTO {

  identifier: string;
  project: any;
  division: any;


  award: AwardDTO;

  tenderRequestedMaterial: TenderRequestedMaterialDTO;
  requestedMaterial: RequestMaterialDTO;

  unitPrice: number;
  amount: number;

  task: TaskDTO;

}
export class ContractRequestedMaterialDTO {

  identifier: string;
  project: any;
  lote: LotDTO;
  division: any;
  orderNumber: string;


  contract: ContractDTO;

  awardRequestedMaterial: AwardRequestedMaterialDTO;

  unitPrice: number;
  amount: number;

  task: TaskDTO;

}


export class ContractRequestedMaterialFilterDTO {
  contract: ContractDTO;
  description: string;
  supplierReference: string;
  referenceCode: string;
}
export class AwardRequestedMaterialFilterDTO {
  award: AwardDTO;
  description: string;
  supplierReference: string;
  referenceCode: string;


}
export class TenderRequestedMaterialFilterDTO {
  tender: TenderV2DTO;
  description: string;
  supplierReference: string;
  referenceCode: string;
}

export class RequestedMaterialFilter {
  lot: ProcurementProjectLotDTO


}


export class SpecialExecutionConditionDTO {
  // Tipo de condiciones especiales
  type: MasterDataDTO;
  identifier: string;
  selected: number;
  description: string;
  lot: ProcurementProjectLotDTO;
  listaLotes: ProcurementProjectLotDTO[];

  static patchDTO(dto: SpecialExecutionConditionDTO) { }
  contructor() {
    SpecialExecutionConditionDTO.patchDTO(this);
  }
}

export class SocClausesAwardCritDTO {
  identifier: string;
  tenderCriteriaType: MasterDataDTO; // CS_CRITERIOS_ADJUDICACION.ID_CRITERIO_ADJ
  lot: ProcurementProjectLotDTO; // CS_CRITERIOS_ADJUDICACION.LOTEID
  type: MasterDataDTO; // CS_CRITERIOS_ADJUDICACION.ID_TIPO_CRITERIO
  selected: number; // CS_CRITERIOS_ADJUDICACION.SELECCIONADO
  weighing: number // CS_CRITERIOS_ADJUDICACION.PONDERACION
  description: string; // CS_CRITERIOS_ADJUDICACION.DETALLE

  static patchDTO(dto: SocClausesAwardCritDTO) { }
  contructor() {
    SocClausesAwardCritDTO.patchDTO(this);
  }
}

export class DesglosableInfoDTO {
  cpvs: Array<CPVDTO>;
  criteriaTechnicalFinancial: Array<TechnicalFinancialEvaluationCriteriaDTO>;
  classificationCompany: Array<ClassificationSchemaDTO>;
  selectionAwardCriteria: Array<CriteriaDTO>;
  tariff: Array<TariffDTO>;
  partialDeliveries: Array<PartialDeliveriesDTO>;
  unitPrice: Array<UnitPriceDTO>;
  requestedMaterial: Array<RequestMaterialDTO>;
  specialExecutionCondition: Array<SpecialExecutionConditionDTO>;

  static patchDTO(dto: DesglosableInfoDTO): DesglosableInfoDTO {
    if (!dto) {
      dto = new DesglosableInfoDTO();
    } else {
      if (!dto.cpvs) {
        dto.cpvs = [];
      }
      if (!dto.classificationCompany) {
        dto.classificationCompany = [];
      }
      if (!dto.criteriaTechnicalFinancial) {
        dto.criteriaTechnicalFinancial = [];
      }
      if (!dto.selectionAwardCriteria) {
        dto.selectionAwardCriteria = [];
      }
      if (!dto.tariff) {
        dto.tariff = [];
      }
      if (!dto.partialDeliveries) {
        dto.partialDeliveries = [];
      }
      if (!dto.unitPrice) {
        dto.unitPrice = [];
      }
      if (!dto.requestedMaterial) {
        dto.requestedMaterial = [];
      }
      if (!dto.specialExecutionCondition) {
        dto.specialExecutionCondition = [];
      }
    }
    return dto;
  }

  contructor() {
    DesglosableInfoDTO.patchDTO(this);
  }
}
export class PriceRevisionFormulaDTO {
  identifier: string;
  formula: string;
  formulaId: MasterDataDTO;

  static patchDTO(dto: PriceRevisionFormulaDTO): PriceRevisionFormulaDTO {
    if (!dto) {
      dto = new PriceRevisionFormulaDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    PriceRevisionFormulaDTO.patchDTO(this);
  }
}
export class PriceRevisionDTO {
  priceRevision: MasterDataDTO;
  method: string;
  justificationRevForNo: String;
  justificationRevForYes: String;
  priceRevisionFormula: Array<PriceRevisionFormulaDTO>; // formula de revision de precios

  static patchDTO(dto: PriceRevisionDTO): PriceRevisionDTO {
    if (!dto) {
      dto = new PriceRevisionDTO();
    } else {
      if (!dto.priceRevisionFormula) {
        dto.priceRevisionFormula = [];
      }
    }
    return dto;
  }

  contructor() {
    PriceRevisionDTO.patchDTO(this);
  }
}

export class TenderingTermsDTO {
  tenderValidityPeriod: Date;
  utTenderValidityPeriod: MasterDataDTO;
}

export class WorksDataDTO {
  projExecJoinWork: boolean;
  additionalRCMultiyearWork: boolean;
  obligatoryWorkProjectSupReport: boolean;

  static patchDTO(dto: WorksDataDTO): WorksDataDTO {
    if (!dto) {
      dto = new WorksDataDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    WorksDataDTO.patchDTO(this);
  }
}

// TODO ver si se cambia este DTO por CriteriaDefinitionDTO
export class CriteriaDTO implements ChildOfProjectDTO<number> {
  project: ProjectEntityDTO;
  links: Link[];
  identifier: number;
  task: TaskDTO;
  name: string;
  description: string;
  weight: number;
  awardingCriteriaTypeCode: boolean;
  // solo para cliente
  lot: ProcurementProjectLotDTO;
  transferPriceOffer: string;

  static patchDTO(dto: CriteriaDTO): CriteriaDTO {
    if (!dto) {
      dto = new CriteriaDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    CriteriaDTO.patchDTO(this);
  }
}

export class ContractInformationDTO {
  contractResponsible: string; // responsable del contrato
  note: string; // observaciones
  contactInformation: string; // datos de contacto
  selectionCriteria: Array<CriteriaDTO>;

  static patchDTO(dto: ContractInformationDTO): ContractInformationDTO {
    if (!dto) {
      dto = new ContractInformationDTO();
    } else {
      if (!dto.selectionCriteria) {
        dto.selectionCriteria = [];
      }
    }
    return dto;
  }

  contructor() {
    ContractInformationDTO.patchDTO(this);
  }
}

export class TenderRequirementsDTO {
  codeModeEnvelope: string;
  envelopeDocuments: EnvelopeDocumentDTO[];
  companiesToInvite: CompanyToInviteDTO[];
  static patchDTO(dto: TenderRequirementsDTO): TenderRequirementsDTO {
    if (!dto) {
      dto = new TenderRequirementsDTO();
    } else {
      if (!dto.envelopeDocuments) {
        dto.envelopeDocuments = [];
      }
      if (!dto.companiesToInvite) {
        dto.companiesToInvite = [];
      }
    }
    return dto;
  }

  contructor() {
    TenderRequirementsDTO.patchDTO(this);
  }
}

export class CompanyToInviteDTO {
  awarded: boolean;
  company: CompanyDTO;
}

export class EnvelopeDocumentDTO {
  identifier: any;
  task: TaskDTO;
  envelope: EnvelopeDTO;
  required: boolean;
  requiresSignature;
  name: string;
  description: string;
  uuid: string;
  order: number;
  typeMark: MasterDataDTO;
  see: boolean;
  corrected: boolean;
  documentFile: FileDetailsDTO;
  documentName: string;
}

export class EnvelopeDTO implements ChildOfProjectDTO<string> {
  links: Link[];
  project: ProjectEntityDTO;
  lots: Array<ProcurementProjectLotDTO>;
  lotGroups: Array<ProcurementProjectLotGroupDTO>;
  type: MasterDataDTO;
  description: string;
  order: number;
  files: Array<EnvelopeDocumentDTO>;
  identifier: string;
  task: TaskDTO;
  committee: ProcurementCommitteeDTO;
  phase: TenderingPhaseDTO;
}

// export class ContractInfoDTO {
//   criteriaCompany: CriteriaDTO[];
//   criteriaContract: CriteriaDTO[];
// }

// export class CriteriaDTO {
//   identifier: string;
//   // normalizedWeigh: number; no se envia
//   name: string;
//   description: string;
//   formula: any;
//   weight: number;
//   parentAwardCriteria: any;
//   awardingCriteriaTypeCode: boolean; // evaluable mediante formulas
//   direction: any;
//   // group: any; -> Se establece directamente en servidor
// }

// export class ExecutionInfoDTO {
//   // lugar de entrega
//   location: string;
//   planning: ExecutionPlanningDTO;
//   constructor() {
//     this.planning = new ExecutionPlanningDTO();
//   }
// }

// export class ExecutionPlanningDTO {
//   // fecha prevista de inicio de ejecucion
//   expectedStartDate: Date;
//   // periodo maximo de ejecucion
//   maximumTimeFrame: number;
//   // UT periodo maximo de ejecucion
//   maximumTimeFrameUnit: MasterDataDTO;
//   // fecha limite de ejecucion
//   limitDate: Date;
//   // Observaciones a los plazos de ejecucion
//   remarks: string;
// }

// export class BudgetLineDTO {
//   identifier: string;
//   functional: string;
//   year: number;
//   economical: string;
//   organic: string;
//   amountWithTaxes: number;
// }

export class GuaranteesDTO {
  existsProvisional: boolean;
  provisional: number;
  amountProvisional: number;
  existsDefinitive: boolean;
  definitive: number;
  guaranteeTerm: number;
  guaranteeTermUnit: MasterDataDTO;
  justificationNotGuarantee: string;
}

//////////////////////////////////////////////////////////////
// DTOs asociados a la auditoria de actividad de la aplicación
//////////////////////////////////////////////////////////////
export class EventAuditFiltersDTO {
  from: Date;
  to: Date;
  user: UserDTO;
  size: number;
  operationTimeFrom: number;

  constructor() {
    this.size = 100;
  }
}

export class EventAuditDTO {
  links: Link[];
  identifier: string;
  date: Date;
  resourceId: string;
  success: boolean;
  ip: string;
  responseCount: number;
  type: string;
  operation: string;
  user: UserDTO;
  operationTime: number;
}

export class AudMessageFilterDTO {
  user: UserDTO;
  from: Date;
  to: Date;
  messageType: string;
  actionType: string;
  dossierId: string;
  documentClassId: string;
  orderNumber: number;
  division: number;
  size: number;
  constructor() {
    this.size = 100;
  }
}

export class AudMessageDTO {
  identifier: String;
  audOperationDTO: AudOperationDTO;
  entityId: string;
  user: UserDTO;
  audFileMessage: AudFileMessageDTO;
  date: Date;
  projectId: string;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  division: DivisionDTO;
  lotId: string;
  documentDescription: string;
  userDescription: string;
}

export class AudOperationDTO {
  actionType: string;
}

export class AudFileMessageDTO {
  messageType: string;
  file: FileDetailsDTO;
  date: Date;
}

export class EventAuditStatisticsFiltersDTO {
  timeUnit = 'Days';
  from: Date;
  to: Date;
  type: string;
  overView = true;
}

export class EventAuditStatisticDTO {
  links: Link[];
  identifier: string;
  operation: string;
  type: string;
  maxTime: number;
  averageTime: number;
  minTime: number;
  count: number;
  period: string;
}

///////////////////////////////////////////
// DTOs asociados a la consulta de los log de la aplicacion
///////////////////////////////////////////
export class LogDTO {
  date: Date;
  identifier: string;
  size: number;
  name: string;
  group: string;
}

///////////////////////////////////////////
// DTOs asociados a la gestión de los timers
///////////////////////////////////////////
export enum TimerStatusTypeDTO {
  STARTED = 'started',
  STOPPED = 'stopped',
  ERROR = 'error'
}

export class TimerDTO {
  identifier: string;
  type: number;
  // type == 0
  idleTime: number;

  // type == 1
  schedulerExpression: string;
  schedullerClass: string;

  // type == 2
  initialRepetitions: number;

  // jndi: string;
  configurationStatus: TimerStatusTypeDTO;
  actualStatus: TimerStatusTypeDTO;
  nextExecutions: Array<TimerNextExecution>;
  initialStartDate: string;
  activeNode: Boolean;
}

export class TimerNextExecution {
  schedule: Date;
  state: string;
}

export class SessionDTO {
  identifier: string;
  lastConnectionDate: Date;
  loginDate: Date;
  user: UserDTO;
  uuid: string;
  links: Link[];
  clientType: boolean;
  constructor() {
    this.loginDate = this.lastConnectionDate;
    this.clientType = true;
  }
}

///////////////////////////////////////////
// DTOs asociados a la gestión licencias
///////////////////////////////////////////
export class LicenseDTO {
  typeLicense: string; // "Completa",
  identifier: string; // "serverplyca",
  identifierFile: string; // "4b4707dd-f54f-451c-a00f-ace23d0fddd7",
  active: boolean; // false,
  hostNameActive: string; // "localhost.localdomain",
  numGuestUsersActiv: number; // "20",
  moreInvitsAlloweb: boolean; // true,
  valid: boolean; // true,
  expired: boolean; // false,
  dateExpired: string;
  task: TaskDTO;
  numusersActiv: number; // "20",
  moreUsersAllowed: boolean; // true,
  nameApplication: string; // "PLYCA",
  numUsers: number; // "50"
}

///////////////////////////////////////////
//
///////////////////////////////////////////
export class ReceiveNotifsDTO {
  'receiveNotifications': boolean;
}

export class RuleDTO {
  links: Link[];
  identifier: any;

  date: Date;
  name: string;
  description: string;
  division: DivisionDTO;
  executionType: string;
  severity: string;
  state: string;
  type: string;
  subType: string;
  argumentsHash: string;

  openingMode: string; // Indica desde donde se puede procesar una tarea

  iteration: number;
  instance: number;
  version: number;

  phase: MasterDataDTO;
  parameters: Array<RuleParameters>;

  procedure: ProcedureDTO;
  task: TaskDTO;

  locked: boolean;
  lockedBy: UserDTO;

  availableActions: LinkedActionsDTO;

  executionStatus: ExecutionStatusDTO;
  relatedTasks: TaskDTO[];
}

export class ExecutionStatusDTO {
  procedure: ProcedureDTO;
  document: DocumentDTO;
}

export enum RuleOpeningModeTypeDTO {
  webClientOnly = 'webClientOnly',
  appletOnly = 'appletOnly',
  both = 'both'
}
export enum RuleExecutionTypes {
  MANUAL = 'manual',
  AUTOMATIC = 'automatic'
}
export enum RuleTypes {
  PROCEDURE = 'procedure',
  TASK = 'task',
  SERVER = 'serverAction'
}
export enum RuleStates {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  DISCARTED = 'discarted'
}
export enum RuleSeverities {
  RECOMMENDATION = 'recommendation',
  OPTIONAL = 'optional',
  MANDATORY = 'mandatory'
}

export enum RuleWorkStates {
  STATELESS = 'stateLess', // -1
  INITIAL = 'initial', // 0
  IN_PROGRESS = 'inProgress', // 1
  COMPLETED = 'completed' // 2
}

export class RuleParameters {
  name: string;
  type: string;
  value: string;
}

export class PeriodDTO {
  startDate: Date;
  endDate: Date;
}

export class PartyDTO {
  description: string;
  partyAddress: AddressDTO;

  static patchDTO(dto: PartyDTO): PartyDTO {
    if (!dto) {
      dto = new PartyDTO();
    } else {
      dto.partyAddress = AddressDTO.patchDTO(dto.partyAddress);
    }
    return dto;
  }

  contructor() {
    PartyDTO.patchDTO(this);
  }
}

export class EventDTO {
  description: string;
  ocurrenceDateTime: Date;
  ocurrenceLocation: AddressDTO;

  static patchDTO(dto: EventDTO): EventDTO {
    if (!dto) {
      dto = new EventDTO();
    } else {
      dto.ocurrenceLocation = AddressDTO.patchDTO(dto.ocurrenceLocation);
    }
    return dto;
  }

  contructor() {
    EventDTO.patchDTO(this);
  }
}

export class AddressDTO {
  identifier: string; //
  name: string; // ???
  description: String;
  number: Number;
  country: MasterDataDTO;
  streetType: string; //
  province: MasterDataDTO;
  town: string;
  addressType: MasterDataDTO; //
  postCode: string;
  stair: string;
  storey: string;
  door: string;
  phone1: string;
  phone2: string;
  phone3: string;
  kilometer: string;
  electronicAddress: string;
  url: string;
  fax: string;

  // datos del objeto referenciado
  objectIdentifier: string;
  documentClass: MasterDataDTO;

  static patchDTO(dto: AddressDTO): AddressDTO {
    if (!dto) {
      dto = new AddressDTO();
    } else {
    }
    return dto;
  }

  toString(): string {
    let txt = '';
    if (this.name) {
      txt += this.name;
    }

    if (this.number) {
      txt += ' Nº ' + this.number;
    }

    if (txt === '') {
      txt = '<Dirección incompleta>';
    }
    return txt;
  }

  contructor() {
    AddressDTO.patchDTO(this);
  }
}

export class AwardDTO extends ContextDTO {


  static AWARDSTATE_PENDING = 0;
  static AWARDSTATE_AWARDED = 1;
  static AWARDSTATE_FORMALIZED = 2;
  static AWARDSTATE_DESISTIDO = 3;
  static AWARDSTATE_DESIERTO = 4;

  // BaseEntityDTO
  document: DocumentDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;

  identifier: string;
  task: TaskDTO;
  tender: TenderV2DTO;
  company: CompanyDTO;
  companyDoc: CompanyDocDTO;
  contractNumber: number; // number???
  awardDescription: string;
  description: string;

  awardDate: Date;
  formalizationDate: Date;
  // PLYCACODE_PLAZOFORMALIZACION_RECURSOESPECIAL (0),
  // PLYCACODE_PLAZOFORMALIZACION_GENERAL(1)
  formalizationAwardDate: any; // ver

  limitConstitutionGuaranteeDate: Date;

  pyme: boolean;
  reason: string;
  relatedProject: boolean;

  awardLot: boolean;
  awardsLots: AwardLotDTO[];
  warranties: WarrantyDTO[];

  amountTotalMinor: number;
  amountGoods: number;
  economicalProp: string;

  readjustedPrice: boolean;
  readjustedBudget: number;
  readjustedBudgetTax: number;
  readjustedBudgetwithoutTax: number;
  adjudicationCoefficient: number;

  division: DivisionDTO;

  desistido: boolean;
  desierto: boolean;

  isVisibleConcesion: boolean;
  isEditableCompany: boolean;
  unitPrice: UnitPriceDTO[] = [];

  cofinancedLines: CofinancingLineDTO[];
  budgetAccountLines: BudgetAccountLineDTO[];

  // 0 pendiente de adjudicar
  // 1 adjudicado
  // 2 formalizado
  // 3 desistido
  static getState(dto: AwardDTO) {
    if (dto.desierto) {
      return AwardDTO.AWARDSTATE_DESIERTO;
    } else if (dto.formalizationDate) {
      return AwardDTO.AWARDSTATE_FORMALIZED;
    } else if (dto.awardDate) {
      return AwardDTO.AWARDSTATE_AWARDED;
    } else if (dto.desistido) {
      return AwardDTO.AWARDSTATE_DESISTIDO;
    } else {
      return AwardDTO.AWARDSTATE_PENDING;
    }
  }
}

export class AwardLotDTO {
  amount: number;
  amountTax: number;
  amountwithoutTax: number;
  amountGoods: number;
  projectLot: ProcurementProjectLotDTO;
}

export class WarrantyDTO {
  identifier: string;
  description: string;
  division: DivisionDTO;
  projectLot: ProcurementProjectLotDTO;
  modality: MasterDataDTO;
  amount: number;
  percentage: number;
  deadLine: Date;
  type: MasterDataDTO;
  code: string;

  listaLotes: LotDTO[];
}

export class ReportDTO {
  identifier: string;
  task: TaskDTO;
  // reportingType: MasterDataDTO;
  reportingType: MasterDataDTO;
  description: string;
  urlReport: string;
  urlReportEdition: string;
  group: string;
  links: Link[];
  name: string;
  profiles: ReportProfileDTO[];
  allProfiles: ProfileDTO[];
  allProfilesSelected: ProfileDTO[];
  availableActions: LinkedActionsDTO;
}
export class ReportLoginDTO {

  user: UserDTO;

}

export class ReportProfileDTO {
  profile: ProfileDTO;
}

export class CircuitoDTO {
  identifier: string;
  name: string;
  typeCircuito: MasterDataDTO;
  documentClass: DocumentClassDTO;
  config: CircuitConfigDTO;
  listCircuitStepDTO: StepCircuitoDTO[];
}

export enum CircuitFilterModeDTO {
  All = 'All',
  Mandatory = 'Mandatory',
  Extension = 'Extension'
}

export class StepCircuitoDTO {
  identifier: string;
  stepRol: string; // Tramitador, Firmante
  profile: ProfileDTO; // Perfil
  typeStep: string; // Tipo de paso
  inbox: InboxDTO; // buzon
}

export class CompanyDTO {
  addresses: Array<AddressDTO>; // [{country: "11", identifier: "116", streetType: "Calle", stair: "3", town: "Las Rozas",…}]
  commercialName: string;
  context: any;
  identifier: string;
  task: TaskDTO;
  links: Link[];
  locked: boolean;
  name: string;
  email: string;
  effectiveDate: Date;
  dateExpired: Date;
  comment: string;
  externalIdentifier: string;
  socialObject: string;
  tempTaxIdentifier: boolean;
  previousData: Array<CompanyHistoryDTO>; // [{identifier: 49,…}, {identifier: 50,…}, {identifier: 51,…}, {identifier: 52,…}]
  representatives: Array<RepresentativeDTO>; // [{identifier: "66", lastName: "López",…}, {identifier: "67", lastName: "García",…}]
  socialIntegration: boolean;
  society: MasterDataDTO; // {identifier: "A<>RIL_SOCIETY_TYPE", context: {}, description: "Anónima",…}
  suspend: boolean;
  taxIdentifier: string;
  temporaryConsortium: boolean;
  consortiumParticipations: Array<ConsortiumParticipationDTO>;
  type: MasterDataDTO; // {identifier: "E<>RIL_TIPO_PERSONALIDAD", context: {}, description: "Empresa",…}
  uuid: string;
  ext: any;
  data: any;
  customFields: any;
  nationality: MasterDataDTO;
  synchronize: boolean;
  pyme: boolean;
  pymeType: MasterDataDTO;
  hasRilFile: boolean;

  public static getCompanyDescription(company: CompanyDTO): string {
    let description: string;
    if (company) {
      description = (company.name) ? company.name : company.commercialName;
      if (!description) {
        description = company.taxIdentifier;
      }
    }
    return description || '';
  }
}

export class CompanyFilterDTO {
  taxIdentifier: string;
  commercialName: string;
  name: string;
  ril: boolean;
  size: number;

  constructor() {
    this.size = 100;
  }
}

export class RepresentativeDTO {
  identifier: string;
  uuid: string;
  surname: string;
  lastName: string;
  name: string;
  nature: string;
  externalIdentifier: string;
  leadingRepresentative: boolean;
  representativePower: MasterDataDTO;
  agentLimits: number;
  taxIdentifier: string;
  limit: number;
  country: string;
  representationType: MasterDataDTO;
  addresses: Array<AddressDTO>;
  parent: CompanyDTO;
  description: string;

  static getFullName(representative: RepresentativeDTO) {
    let fullName = representative.name;
    if (representative.surname) {
      fullName += ' ' + representative.surname;
    }
    if (representative.lastName) {
      fullName += ' ' + representative.lastName;
    }
    return fullName;
  }
}

export class CompanyHistoryDTO {
  identifier: string;
  uuid: string;
  userId: string;
  date: Date;
  info: string;
}

export class ConsortiumParticipationDTO {
  identifier: string;
  percentage: number;
  memberUTE: CompanyDTO;
}

export class PublicationInfoDTO {
  // uuid: string;

  privatePublication: boolean;
  // privatePublicationVisibility: boolean;
  // publicationVisibility: boolean;

  webPublication: boolean;
  // webPublicationDateVisibility: boolean; // Date?

  additionalInformationParty: PartyDTO;
  // additionalInformationPartyAdrressVisibility: boolean;
  // additionalInformationPartyDescriptionVisibility: boolean;

  // // fecha perfil contratante
  buyerProfileIssueDate: Date;
  // buyerProfileIssueDateVisibility: boolean;

  configurableIssueDate: Date;
  // configurableIssueDateVisibility: boolean;

  issueDateBOC: Date;
  // issueDateBOCVisibility: boolean;

  issueDateBOE: Date;
  // issueDateBOEVisibility: boolean;

  issueDateDOUE: Date;
  // issueDateDOUEVisibility: boolean;

  objetiveCriteriaPeriod: Date; //
  // subjectiveCriteriaPeriod: Date; //

  openingTenderParty: EventDTO;
  // openingTenderPartyAdressVisibility: boolean;
  // openingTenderPartyDescriptionVisibility: boolean;
  // openingTenderPartyOcurrenceTimeVisibility: boolean; // ??

  // // solicitudes de participacion
  // participationRequestReceptionPeriodVisibility: boolean;
  participationRequestReceptionPeriod: PeriodDTO; // {endDate: 1406116800000, startDate: 1406109600000}

  tenderReceptionPeriod: PeriodDTO; // {endDate: 1406116800000, startDate: 1406109600000}
  // tenderReceptionPeriodVisibility: false;

  tenderRecipientParty: PartyDTO; // {description: "Lugar ofertas"}
  // tenderRecipientPartyAdrressVisibility: boolean;
  // tenderRecipientPartyDescriptionVisibility: boolean;

  // links: Link[];

  static patchDTO(dto: PublicationInfoDTO): PublicationInfoDTO {
    if (!dto) {
      dto = new PublicationInfoDTO();
    } else {
      dto.additionalInformationParty = PartyDTO.patchDTO(
        dto.additionalInformationParty
      );
      dto.tenderRecipientParty = PartyDTO.patchDTO(dto.tenderRecipientParty);
      dto.openingTenderParty = EventDTO.patchDTO(dto.openingTenderParty);
    }
    return dto;
  }

  contructor() {
    PublicationInfoDTO.patchDTO(this);
  }
}

// Objeto para representar la planificacion de un expediente
export class PlanificationDTO {
  description: string;
  diasRetrasoConf: number;
  diasRetrasoHistorico: number;
  diasRetrasoObjetivo: number;
  fechaReal: string;
  fechaEstimadaConf: string;
  fechaEstimadaHistorico: string;
  fechaEstimadaObjetivo: string;
  fechaObjetivo: string;
  idFecha: string;
  plazoReal: string;
  plazoConf: string;
  plazoHistorico: string;
}

export enum DataTypeDTO {
  Text = 'Text',
  string = 'String',
  Date = 'Date',
  Number = 'Number',
  Range = 'Range',
  Timestamp = 'Timestamp',
  Decimal = 'Decimal',
  Boolean = 'Boolean',
  Object = 'Object',
  MasterData = 'MasterData'
}

export enum DocumentCategories {
  Notification = 'Notification',
  Others = 'Others',
  Oferta = 'Oferta',
  ExpedienteIncidencia = 'ExpedienteIncidencia',
  S1 = 'S1',
  S2 = 'S2',
  S3 = 'S3',
  S4 = 'S4',
  Expediente = 'Expediente',
  ModeloExpediente = 'ModeloExpediente',
  FichaExpediente = 'FichaExpediente',
  Adjudicacion = 'Adjudicacion',
  FichaAdjudicacion = 'FichaAdjudicacion',
  MesaContratacion = 'MesaContratacion',
  Organismo = 'Organismo',
  Representante = 'Representante',
  Empresa = 'Empresa',
  SolicitudAperturaSobre = 'SolicitudAperturaSobre',
  SubFaseLicitacion = 'SubFaseLicitacion',
  FichaIncidencia = 'FichaIncidencia',
  FichaRegistro = 'FichaRegistro',
  Mail = 'Mail',
  Persona = 'Persona'
}

export class UnstructuredDocumentDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
}

// DTOS relacionados con el gestor de comunicaciones
export enum CommunicationDirectionType {
  IN = 'IN',
  OUT = 'OUT'
}

export class CommunicationEventEntity implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  name: string;
}

export class CommunicationEventDTO implements BaseObjectDTO<number> {
  links: Link[];
  identifier: number;
  task: TaskDTO;
  parent: CommunicationDTO;
  date: Date;
  description: string;
  observations: string;
  actionId: string;
  actionDescription: string;
  uuid: string;
  entity: CommunicationEventEntity;
  agent: CommunicationEventEntity;
}

export class CommunicationErrorDTO implements BaseObjectDTO<number> {
  links: Link[];
  identifier: number;
  task: TaskDTO;
  parent: CommunicationDTO;
  description: string;
  uuid: string;
  code: string;
}

export class CommunicationParamDTO extends BaseDataDTO
  implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  parent: CommunicationDTO;
}

export class CommunicationParamActionDTO implements BaseObjectDTO<number> {
  links: Link[];
  identifier: number;
  task: TaskDTO;
  parent: CommunicationActionDTO;
  name: string;
  value: string;
}

export class CommunicationActionDTO implements BaseObjectDTO<number> {
  links: Link[];
  identifier: number;
  task: TaskDTO;
  parent: CommunicationDTO;
  actionType: MasterDataDTO;
  valid: boolean;
  executed: boolean;
  params: Array<CommunicationParamActionDTO>;
}

export class CommunicationDocumentDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  parent: CommunicationDTO;
  document: DocumentDTO;
  addToElectronicEnvelope: boolean;
  versionNumber: number;
  order: number;
  documentVersion: DocumentVersionDTO;

  static sameObject(
    doc1: CommunicationDocumentDTO,
    doc2: CommunicationDocumentDTO
  ): boolean {
    let sameObject = false;
    if (doc1.identifier && doc2.identifier) {
      sameObject = doc1.identifier === doc2.identifier;
    } else if (doc1.document && doc2.document) {
      // alguno de los documentos o ambos no se han dado de alta aun
      // comparar tipo documento y version
      if (
        (doc1.document.entity && doc1.document.entity.documentClass) ||
        (doc2.document.entity && doc2.document.entity.documentClass)
      ) {
        sameObject =
          doc1.document.entity.documentClass.identifier ===
          doc2.document.entity.documentClass.identifier;
      }
      if (sameObject) {
        sameObject = doc1.document.entity.orderNumber === doc2.document.entity.orderNumber;
      }
      if (sameObject) {
        sameObject = doc1.document.entity.division && doc2.document.entity.division
          && doc1.document.entity.division === doc2.document.entity.division;
      }
    }
    return sameObject;
  }
}

export class CommunicationChannelPropertiesDTO
  implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  key: string;
  value: string;
  description: string;
  parent: CommunicationChannelDTO;
}

export class CommunicationChannelDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  name: string;
  description: string;
  visible: boolean;
  enabled: boolean;
  properties: Array<CommunicationChannelPropertiesDTO>;
}

export class CommunicationAgentDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  parent: CommunicationDTO;
  organizationalUnit: OrganizationalUnitDTO;
  company: CompanyDTO;
  person: PersonDTO;
  user: UserDTO;
  agentClass: DocumentCategories;
  companyAgent: RepresentativeDTO;
  email: string;
  order: number;

  static getAgentListDescription(
    agents: CommunicationAgentDTO[],
    defaultDescription?: string
  ): string {
    let description = '';
    let separator = '';
    agents.forEach((company: CommunicationAgentDTO) => {
      description +=
        separator +
        CommunicationAgentDTO.getAgentDescription(company, defaultDescription);
      separator = '; ';
    });
    return description || defaultDescription;
  }

  static getAgentDescription(
    agent: CommunicationAgentDTO,
    defaultDescription?: string
  ): string {
    let description: string;
    if (agent.agentClass === DocumentCategories.Empresa) {
      description = agent.company.name || agent.company.commercialName;
      if (agent.companyAgent) {
        description = RepresentativeDTO.getFullName(agent.companyAgent) + ' - ' + description;
      }
    } else if (agent.agentClass === DocumentCategories.Organismo) {
      description = agent.organizationalUnit.name;
    } else if (agent.agentClass === DocumentCategories.Mail) {
      description = agent.email;
    } else if (agent.agentClass === DocumentCategories.Persona) {
      description = agent.person.fullName;
    }
    return description || defaultDescription;
  }

  static sameObject(
    agent1: CommunicationAgentDTO,
    agent2: CommunicationAgentDTO
  ): boolean {
    let sameObject = false;
    if (agent1.identifier || agent2.identifier) {
      // alguno de los agentes o ambos se han dado de alta
      sameObject = agent1.identifier === agent2.identifier;
    } else {
      // ninguno de los agentes se han dado de alta
      // comparar tipo de agente
      sameObject = agent1.agentClass === agent2.agentClass;
      if (sameObject) {
        if (agent1.agentClass === DocumentCategories.Empresa) {
          // comprobar empresa
          sameObject =
            (agent1.company ? agent1.company.identifier : undefined) ===
            (agent2.company ? agent2.company.identifier : undefined);
          // comprobar representante
          if (agent1.person || agent2.person) {
            sameObject =
              (agent1.person ? agent1.person.identifier : undefined) ===
              (agent2.person ? agent2.person.identifier : undefined);
          }
        } else if (agent1.agentClass === DocumentCategories.Persona) {
          sameObject =
            (agent1.person ? agent1.person.identifier : undefined) ===
            (agent2.person ? agent2.person.identifier : undefined);
        } else if (agent1.agentClass === DocumentCategories.Mail) {
          sameObject = agent1.email === agent2.email;
        }
      }
    }
    return sameObject;
  }
}

export enum CommunicationActivityDivisionSelectorType {
  ZERO = 'ZERO',
  DIVISIONS = 'DIVISIONS',
  BOTH = 'BOTH'
}
export class CommunicationActivityConfigDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  documentClass: DocumentCategories;
  channel: CommunicationChannelDTO;
  visible: boolean;
}

export class CommunicationActivityDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  description: string;
  divisionSelector: CommunicationActivityDivisionSelectorType;
  updatable: boolean;
  configurations: Array<CommunicationActivityConfigDTO>;
}

export enum RegisterConfigType {
  NO_REGISTER = 'NO_REGISTER',
  ELECTRONIC_REGISTER = 'ELECTRONIC_REGISTER',
  MANUAL_REGISTER = 'MANUAL_REGISTER'
}

export class RegisterInfoDTO {
  registerNumber: string;
  date: Date;
}

export class ProcessRegisterInfoDTO {
  registerNumber: number;
  date: Date;
}

export class EnvelopeConfig {
  numberOfReplies: number;
  modifiable: boolean;
  numberOfSignatures: number;
  documentConfig: UnstructuredDocumentDTO;
  tenderingPhase: TenderingPhaseDTO;
  tenderingEnvelopes: Array<EnvelopeDTO>;
  showTenderLots: boolean;
}

export class NotificationProcedureDTO implements BaseObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  links: Link[];
  description: string;
  enabled: boolean;
}

export enum CommunicationStatusType {
  EDITING = 'EDITING',
  SENDING = 'SENDING',
  EXECUTION_PENDING = 'EXECUTION_PENDING',
  SENDED = 'SENDED',
  COMMUNICATION_ERROR = 'COMMUNICATION_ERROR',
  ERROR = 'ERROR'
}

export class CommunicationStatusDTO {
  code: string;
  type: CommunicationStatusType;

  constructor(statusType: CommunicationStatusType) {
    let defaultCode: string;
    switch (statusType) {
      case CommunicationStatusType.EDITING: {
        defaultCode = '000';
        break;
      }
      case CommunicationStatusType.SENDING: {
        defaultCode = '010';
        break;
      }
      case CommunicationStatusType.SENDED: {
        defaultCode = '100';
        break;
      }
      case CommunicationStatusType.EXECUTION_PENDING: {
        defaultCode = '050';
        break;
      }
      case CommunicationStatusType.COMMUNICATION_ERROR: {
        defaultCode = '500';
        break;
      }
      case CommunicationStatusType.ERROR: {
        defaultCode = '600';
        break;
      }
    }
    this.type = statusType;
    this.code = defaultCode;
  }
}

export class CommunicationDTO
  implements BaseEntityDTO, IChildOfDivision, BaseObjectDTO<number> {
  // propiedades AbstractCommunicationDTO
  identifier: number;
  task: TaskDTO;
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  document: DocumentDTO;
  sender: CommunicationAgentDTO;
  receivers: Array<CommunicationAgentDTO>;
  direction: CommunicationDirectionType;
  subject: string;
  body: string;
  status: CommunicationStatusDTO;
  repliedCommunication: CommunicationDTO;
  externalIdentifier: string;
  communicationUUID: string;
  uuid: string;
  deleted: boolean;
  receptionProcessDate: Date;
  sendedDate: Date;
  creationDate: Date;
  project: ProjectEntityDTO;
  channel: CommunicationChannelDTO;
  activity: CommunicationActivityDTO;
  events: Array<CommunicationEventDTO>;
  errors: Array<CommunicationErrorDTO>;
  params: Array<CommunicationParamDTO>;
  actions: Array<CommunicationActionDTO>;
  documents: Array<CommunicationDocumentDTO>;
  // propiedades para distingir subclases
  class: string;
  // propiedades comunicaciones a portal
  timeStamp: boolean;
  register: RegisterConfigType;
  registerInfo: RegisterInfoDTO;
  startDate: Date;
  endDate: Date;
  envelopeConfig: EnvelopeConfig;
  // propiedades notificaciones
  procedure: NotificationProcedureDTO;
  email: string;
  updateStatus: boolean;
  // propiedad de cliente
  responses: Array<CommunicationDTO>;
}
// Fin DTOS relacionados con el gestor de comunicaciones

export class MilestoneDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  typeMilestone: any;
  dossier: DossierDTO;
  observations: string;
  description: string;
  place: string;
  dateMilestone: string;
  identifierChain: string;
  uniqueIdentifier: string;
  project: ProjectEntityDTO;
  calendarEvent: {};
  division: any;

}

export class HelpInterface {
  protected helpService: HelpService;
  tags: string[];
  constructor() {
    this.helpService = ServiceLocator.injector.get(HelpService);
    this.helpService.getStoreTagsObservable().pipe(
      switchMap((helpTags) => this.tags = helpTags)).subscribe();
  }
}

// export interface TypeMillestoneDTO extends BaseObjectDTO<string> {
//   description: string;
//   identifierChain: string;
//   uniqueIdentifier: string;
// }

/**
 * Metodo que limpia la referencia a otro DTO manteniendo el identificador
 *
 * @param object nombre del objeto a limpiar
 * @param propertyName nombre de la propiedad del objeto a limpiar que referencia a otro DTO
 * @param objIndex En el caso de Arrays indice del DTO referenciado a limpiar
 */
export function cleanReferencedDto(
  object: any,
  propertyName: string,
  objIndex?: number
): void {
  let parentObject = object;
  let dtoRef =
    objIndex > -1
      ? parentObject[propertyName][objIndex]
      : parentObject[propertyName];
  let newDto = {} as any;
  if (dtoRef) {
    if (dtoRef instanceof Array) {
      dtoRef.forEach((value: any, elementIndex: number) =>
        cleanReferencedDto(object, propertyName, elementIndex)
      );
    } else {
      newDto.identifier = dtoRef.identifier;
      if (objIndex > -1) {
        parentObject[propertyName][objIndex] = newDto;
      } else {
        parentObject[propertyName] = newDto;
      }
    }
  }
}

///////////////////////////////////////////
// DTOs asociados a Ficha Incidencia
///////////////////////////////////////////
export class ContractModificationConfigurationDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  contractModificationType: MasterDataDTO;
  available: boolean;
  reason: string;
}


export enum CompensationType {
  A_FAVOR = 'F',
  EN_CONTRA = 'C'
}

export class ContractModificationPriceRevDTO {
  system: string; // Sistema de Rev. de Precios: EXPTEINCIDENCIA.SISTEMA_REVPRECIOS
  coefficient: string; // Coeficiente de Rev.: EXPTEINCIDENCIA.COEFICIENTE
  priceRevisionFormula: Array<PriceRevisionFormulaDTO>; // formula de revision de precios

  static patchDTO(
    dto: ContractModificationPriceRevDTO
  ): ContractModificationPriceRevDTO {
    if (!dto) {
      dto = new ContractModificationPriceRevDTO();
    } else {
      if (!dto.priceRevisionFormula) {
        dto.priceRevisionFormula = [];
      }
    }
    return dto;
  }

  contructor() {
    ContractModificationPriceRevDTO.patchDTO(this);
  }
}

export class ContractModificationBudgetDTO {
  taxType: MasterDataDTO; // Tipo de Impuesto: EXPTEINCIDENCIA.TIPO_IVA
  totalAmount: number; // Importe de la Incidencia: EXPTEINCIDENCIA.IMPORTE
  amountExcludingTaxes: number; // Importe sin Impuestos-IVA: EXPTEINCIDENCIA.IMPORTE_SIVA
  totalTaxes: number; // Importe del Impuesto-IVA: EXPTEINCIDENCIA.TOTALIMPUESTO
  taxRate: string; // Tipo Impositivo: EXPTEINCIDENCIA.TIPOIMPOSITIVO

  percentageContractAmount: string; // Porcentaje del importe de Contrato EXPTEINCIDENCIA1.PORCENTAJE_IMPCONTRATO
  auxAmount: number; // Campo auxiliar de tipo importe (puede ser utilizado en diferentes tipos de incidencia)EXPTEINCIDENCIA.IMPORTE_VARIOS
  delayInterests: number; // Intereses por demora
  compensationType: CompensationType; // Tipo de Indemnizacion: EXPTEINCIDENCIA.TIPO_INDEMNIZACION

  priceVariation: number; // Variación de Precio: EXPTEINCIDENCIA.VAR_PRECIO
  cumulativePriceVariation: number; // Variación de Precio Acumulado: EXPTEINCIDENCIA.VAR_PACUMULADO
  amountDay: number; // Euros al día: EXPTEINCIDENCIA.EUROS_DIA

  noBudget: boolean; // Sin gasto: EXPTEINCIDENCIA.SIN_GASTO

  budgetAccountLines: BudgetAccountLineDTO[]; // Anualidades de la Incidencia ANUALIDADAPLICACION
  cofinancedLines: CofinancingLineDTO[]; // Cofinanciación de la Incidencia COFINANCIACION


  unitPrice: UnitPriceDTO[]; // Precios Unitarios de la Incidencia

  priceRevision: ContractModificationPriceRevDTO; // Datos de Revisión de Precios

  // Datos de registro
  registerTaxType: MasterDataDTO; // Tipo de Impuesto: EXPTEINCIDENCIA.TIPO_IVA_RECO
  registerTaxRate: string; // Tipo Impositivo: EXPTEINCIDENCIA.TIPOIMPOSITIVO_RECO
  budgetVariation: number; // Variacion del presupuesto: EXPTEINCIDENCIA1.VARIACION_PRESUPUESTO
  registerTotalAmount: number; // IMPORTE_RECO
  registerTotalTaxes: number; // TIPO_IMPUESTO_RECO
  registerAmountExcludingTaxes: number; // IMPORTE_SIVA

  auxTaxRate: string; // EXPTEINCIDENCIA1.TIPOIMPOSITIVO_VARIOS
  auxTaxType: MasterDataDTO; // EXPTEINCIDENCIA1.TIPO_IVA_VARIOS
  auxTotalTaxes: number; // EXPTEINCIDENCIA1.TOTALIMPUESTO_VARIOS

  guaranteeAmount: number; // EXPTEINCIDENCIA.IMPORTE_GARANTIA

  static patchDTO(
    dto: ContractModificationBudgetDTO
  ): ContractModificationBudgetDTO {
    if (!dto) {
      dto = new ContractModificationBudgetDTO();
    } else {
      dto.priceRevision = new ContractModificationPriceRevDTO();
      if (!dto.priceRevision.priceRevisionFormula) {
        dto.priceRevision.priceRevisionFormula = [];
      }

      if (!dto.budgetAccountLines) {
        dto.budgetAccountLines = [];
      }

      if (!dto.unitPrice) {
        dto.unitPrice = [];
      }
    }
    return dto;
  }

  contructor() {
    ContractModificationBudgetDTO.patchDTO(this);
  }
}

export enum DurationType {
  TEMPORAL = 'T',
  DEFINITIVO = 'D'
}

export class ContractModificationPlannedPeriodDTO {
  duration: number; // Plazo de Duración : EXPTEINCIDENCIA.PLAZO_DURACION
  durationUnit: MasterDataDTO; // UT del Plazo de Duración: EXPTEINCIDENCIA.UTPLAZO_DURACION
  durationMonth: number; // Plazo de Duración en Meses: EXPTEINCIDENCIA.PLAZO_DURACION_MESES
  durationDesc: string; // Descripción de la duracion de la Incidencia: EXPTEINCIDENCIA.DURACION_TEXTO
  durationType: MasterDataDTO; // Tipo de duración de la suspensión: Temporal  o Definitiva Plazo de Duración : EXPTEINCIDENCIA.DURACION
  delateDays: number; // Dias de retraso: EXPTEINCIDENCIA.DIAS_RETRASO

  startDate: Date; // Fecha de Inicio: EXPTEINCIDENCIA.FECHA_INICIO
  endDate: string; // Fecha de Fin: EXPTEINCIDENCIA.FECHA_FIN
  agreementDate: Date; // Fecha de Resolución: EXPTEINCIDENCIA.FECHA_ACUERDO
  auxDate: Date; // Fecha Varios: EXPTEINCIDENCIA.FECHA_VARIOS

  // Resto de fechas utilizadas en diferentes incidencias
  requestDate: Date; // Fecha de Petición: EXPTEINCIDENCIA.FECHA_PETICION
  technicalReportDate: Date; // Fecha del Informe Técnico: EXPTEINCIDENCIA.FECHA_INF_TECNICO
  buyerProfileDate: Date; // Fecha del Perfil del Contratante: EXPTEINCIDENCIA.FECHA_PUB_PERFIL
  douePublicationDate: Date; // Fecha de Publicación en DOUE: EXPTEINCIDENCIA.FEC_PUB_DOUE

  durationPeriod: string; // Periodo de Tiempo: EXPTEINCIDENCIA.PERIODO

  // Datos de Registro
  executionDate: Date; // Fecha de reanudacion de la ejecucion
  approvalDate: Date; // Fecha de aprobación: EXPTEINCIDENCIA1.FECHA_APROBACION
  formalizationDate: Date; // Fecha de formalización: EXPTEINCIDENCIA.FECHA_FORMALIZACION
  registerContractEndDate: Date; // Fecha de fin de contrato. EXPTEINCIDENCIA1.FECHA_FIN_CONTRATO
  douePublication: boolean; // Publicacion en DOUE (si, no). EXPTEINCIDENCIA1.PUB_DOUE
  resolutionLiftingDate: Date; // Fecha de resolucion del levantamiento de la suspension. EXPTEINCIDENCIA.FECHA_RESOLUCION_LVTO
  resolutionDate: Date; // Fecha de resolucion. EXPTEINCIDENCIA.FECHA_RESOLUCION
  registerDate: Date; // Fecha de Inscripcion. EXPTEINCIDENCIA1.FINSCRIPCION
  registerLiftingDate: Date; // Fecha de Inscripcion del levantamiento. EXPTEINCIDENCIA1.FINSCRIPCION_LVTO
  registerContractLitingEndDate: Date; // Fecha de Inscripcion del levantamiento. EXPTEINCIDENCIA1.FECHA_FIN_CONTRATO_LVTO

  guaranteeDate: Date; // Fecha de incautacion de la garantia. EXPTEINCIDENCIA.FECHA_GARANTIA
  disqualificationDuration: number; // Plazo de la inhabilitacion. EXPTEINCIDENCIA1.PLAZO_INHABILITACION
  disqualificationDurationUnit: MasterDataDTO; // Tipo de plazo de la inhabilitacion. EXPTEINCIDENCIA1.UTPLAZO_INHABILITACION

  static patchDTO(
    dto: ContractModificationPlannedPeriodDTO
  ): ContractModificationPlannedPeriodDTO {
    if (!dto) {
      dto = new ContractModificationPlannedPeriodDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    ContractModificationPlannedPeriodDTO.patchDTO(this);
  }
}

export class ContractModificationCauseDTO {
  generalCause: string;
  generalCauses: MasterDataDTO[];
  generalCauseString: string;
  description: string; // Causa o motivo de la incidencia: EXPTEINCIDENCIA.CAUSA
  registerLiftingCause: string; // EXPTEINCIDENCIA.CAUSALVTO
  registerContractorCause: boolean; // Causa imputable al contratista

  static patchDTO(
    dto: ContractModificationCauseDTO
  ): ContractModificationCauseDTO {
    if (!dto) {
      dto = new ContractModificationCauseDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    ContractModificationCauseDTO.patchDTO(this);
  }
}

enum WarrantyType {
  GARANTIA_AVAL = 'Garantía constituida por aval',
  GARANTIA_SEGURO_CAUCIÓN = 'Garantía constituida por seguro de caución',
  GARANTIA_OTROS = 'Otros'
}

export class ContractModificationWarrantyDTO {
  warranties: WarrantyDTO[]; // Garantias
  type: WarrantyType; // Tipo de Garantia
  warrantyConfiscation: boolean; // Incautación de garantía: EXPTEINCIDENCIA.INC_GARANTIA

  static patchDTO(
    dto: ContractModificationWarrantyDTO
  ): ContractModificationWarrantyDTO {
    if (!dto) {
      dto = new ContractModificationWarrantyDTO();
    } else {
    }
    return dto;
  }

  contructor() {
    ContractModificationWarrantyDTO.patchDTO(this);
  }
}

export class SubcontratedCompanyDTO {
  division: DivisionDTO;
  company: CompanyDTO;
  adjustTender: boolean;
  sme: boolean;
  specialCenter: boolean;
  specialCenterType: MasterDataDTO;
  benefitsAmount: number;
  percentage: number;
  technicalReportDate: Date;
  authorizationDate: Date;
  order: number;
  authorizationReplycaDate: Date;
  name: string;
  pymeType: MasterDataDTO;
}

export class CompanyDocDTO {
  taxIdentifier: string;
  type: string;
  name: string;
  ordinalBank: string;
  representativeTaxIdentifier: string;
  representativeName: string;
  dateSignatureContract: Date;
  formalizationDate: Date;
  address: AddressDTO;
  externalIdentifier: string;
  order: number;
  bankType: string;
  bankCountry: string;
  bankKey: string;
  subParty: string;
  bankAccount: string;
  partyType: string;
  bankIdentifierCode: string;
  temporaryConsortium: boolean;

  static patchDTO(dto: CompanyDocDTO): CompanyDocDTO {
    if (!dto) {
      dto = new CompanyDocDTO();
    }

    return dto;
  }

  contructor() {
    CompanyDocDTO.patchDTO(this);
  }
}

export class RegisterContractModificationErrorDTO {
  error: string;
  errorMotivation: string;
  liftingError: string;
  liftingErrorMotivation: string;
}

// aymad
export class AntecedentLineDTO {
  identifier: any;
  contractModificationIdentifier: string;
  task: TaskDTO;
  description: string;
  agreementDate: Date;
  previousLot: number;
  previousOrderNumber: number;
  budget: number;
  price: number;
  period: number;
  coefficient: number;
}

/**
 * Clase para determinar una incidencia de contrato ***********************
 */
export class ContractModificationDTO {
  context: any;
  division: DivisionDTO;
  identifier: string;
  task: TaskDTO;

  orderNumber: number;

  contract: ContractDTO;

  origin: string; // OriginContractModification;

  // Division de lncidencia (ExpedienteBase)

  // Fin de la division de la incidencia

  // Datos generales de la incidencia
  alias: string; // Alias de la incidencia
  name: string; // Nombre de la incidencia
  contractModificationId: string; // Identificador de la incidencia: EXPTEINCIDENCIA.INCIDENCIAID
  number: string; // Num. de la Incidencia: EXPTEINCIDENCIA.NUMERO
  creationDate: Date; // Fecha de Creación: EXPTEINCIDENCIA.FECHA_ALTA
  registrationNumber: string; // Num. de Registro: EXPTEINCIDENCIA.NUMREGISTRO
  reason: string; // Objeto de la Incidencia: EXPTEINCIDENCIA.OBJETO
  note: string; // Observaciones: EXPTEINCIDENCIA.OBSERVACIONES
  contractNature: string; // Naturaleza: EXPTEINCIDENCIA.NATURALEZA
  increaseDecrease: MasterDataDTO; // Incremento/Decremento: EXPTEINCIDENCIA.INCREMENTO_DECREMENTO

  auxField: MasterDataDTO; // Campo auxiliar de tipo booleano: EXPTEINCIDENCIA.VARIOS
  responsable: Boolean; // EXPTEINCIDENCIA.VARIOS

  // Definición de Importes de la incidencia: Importes de la incidencia,
  // Incrementos, Decrementos, Intereses, Revisión de precios ...
  budget: ContractModificationBudgetDTO;

  // Definición de plazos de la incidencia: Plazos de Duración, Tipo de Duracion,
  // Descripción, Fechas de la incidencia
  plannedPeriod: ContractModificationPlannedPeriodDTO;

  // Causas de la incidencia: Generales, Especcíficas, descripción
  cause: ContractModificationCauseDTO;

  // Garantías de la incidencia
  warranty: ContractModificationWarrantyDTO;

  // RESPONSABLE-EMPRESADOC:
  // commpanyDoc: CompanyDocDTO[];
  company: CompanyDTO;

  companyDoc: CompanyDocDTO;

  // Indica si la empresa es UTE o no
  UTE: boolean;

  // Documento
  document: DocumentDTO;

  // Empresas subcontratadas
  subcontratedCompany: SubcontratedCompanyDTO[];

  // Lista lotes incidencia
  contractModificationLot: ContractModificationLotDTO;

  // Datos del expediente
  procurementProjectInfo: ContractModicationProjectInformationDTO;

  // DATOS DE Registro
  documentationIsCopyOriginalFile: Boolean; // EXPTEINCIDENCIA.DOC_COPIA_ORIGINAL
  liftingDocumentationIsCopyOriginalFile: Boolean; // EXPTEINCIDENCIA.DOC_COPIA_ORIGINAL_LVTO
  contractExtension: MasterDataDTO; // EXPTEINCIDENCIA.TIPO_PRORROGA
  contractExtensionTypesPRC: any[]; // campo auxiliar para los diferentes tipos de prorroga (aymad)
  registerNote: string; // EXPTEINCIDENCIA.OBSERVACIONES_AUX
  registerLiftingNote: string; // EXPTEINCIDENCIA.OBSERVACIONES_LVTO
  registerNumber: string;
  registerLiftingNumber: string;
  causeModificationType: MasterDataDTO;
  notPlannedPCAPCause: MasterDataDTO;
  type: MasterDataDTO; // Tipo de Causa.
  effectDate: Date; // fecha de efectos.
  registerError: RegisterContractModificationErrorDTO; // Registro de errores.

  instanceType: MasterDataDTO; // EXPTEINCIDENCIA.INSTANCIA
  disqualification: Boolean;

  documentClass: DocumentClassDTO;
  hasUnitPrices: Boolean; // EXPTEINCIDENCIA.AFECTA_PRECIOSUNITARIOS (aymad)

  compensation: MasterDataDTO; // EXPTEINCIDENCIA.INDEMNIZACION (aymad)
  determinationBreach: string; // EXPTEINCIDENCIA.DET_INCUMPLIMIENTO (aymad)
  incidentWarranty: MasterDataDTO; // EXPTEINCIDENCIA.GARANTIA (aymad)
  causeAsString: string; // EXPTEINCIDENCIA.CAUSAGENID en las PNC (aymad)
  listCauses: MasterDataDTO[]; // Campo auxiliar para recoger los tipos de incumplimiento seleccionados en la ficha
  temporaryConsortium: MasterDataDTO; // EXPTEINCIDENCIA.UTE (aymad)
  temporaryConsortiumText: string; // Auxiliar para la descripción de temporaryConsortium (aymad)

  // antecedents: AntecedentDTO[];

  static patchDTO(dto: ContractModificationDTO): ContractModificationDTO {
    if (!dto) {
      dto = new ContractModificationDTO();
    } else {
      dto.budget = ContractModificationBudgetDTO.patchDTO(dto.budget);
      dto.budget.priceRevision = ContractModificationPriceRevDTO.patchDTO(dto.budget.priceRevision);
      dto.plannedPeriod = ContractModificationPlannedPeriodDTO.patchDTO(
        dto.plannedPeriod
      );
      dto.cause = ContractModificationCauseDTO.patchDTO(dto.cause);
      dto.warranty = ContractModificationWarrantyDTO.patchDTO(dto.warranty);
      if (!dto.subcontratedCompany) {
        dto.subcontratedCompany = [];
      }


      /*if (!dto.companyDoc) {
        dto.companyDoc = [];
      }*/
    }
    return dto;
  }

  contructor() {
    ContractModificationDTO.patchDTO(this);
  }
}


export class RegisterContractModificationDTO {
  context: any;
  division: DivisionDTO;
  identifier: string;
  task: TaskDTO;
  // Contracto
  contract: ContractDTO;
  // Documento
  document: DocumentDTO;
  contractModification: ContractModificationDTO;
  budgetAccountLines: BudgetAccountLineDTO[];
  // Datos del expediente
  contractInfo: RegisterContractModicationProjectInformationDTO;
  liftingContractModification: boolean;
  projectOrganizationalSnapshot?: any;
  liftingProjectOrganizationalSnapshot?: any;
  previousOrganizationalUnitRegistration: boolean;
}

export class ContractModificationLotDTO {
  amount: number;
  budgetVariation: number;
  priceVariation: number;
  durationVariation: number;
  projectLot: ProcurementProjectLotDTO;
}

export class InvoiceDetailLineBudgetDTO {
  taxType: MasterDataDTO;

  unitAmount: number;
  amountExcludingTaxes: number;
  totalTaxes: number;
  totalAmount: number;
}
export class InvoiceDetailLineDTO {
  entity: InvoiceDTO;
  identifier: number;
  description: string;
  units: number;
  budget: InvoiceDetailLineBudgetDTO;
  // AYMAD - Se usa en AYMAD!!
  auxIdentifier: String
}

export class InvoicePlannedPeriodDTO {
  date: Date;
  inDate: Date;
  accordanceDate: Date;
  paymentPlannedTimeDate: Date;
  paymentPlannedTimeType: MasterDataDTO;
  paymentPlannedTime: number;
  targetDate: Date;
  dueDate: Date;
}

export class InvoiceDTO extends ContextDTO {
  division: DivisionDTO;
  identifier: string;
  orderNumber: number;
  task: TaskDTO;

  descritpion: string;
  company: CompanyDocDTO;
  taxIdentifier: string;

  award: AwardDTO;

  number: string;
  serialNumber: string;

  totalAmount: number;
  totalAmountExcludingTaxes: number;
  detailLines: Array<InvoiceDetailLineDTO>;
  relatedAccountingDocs: Array<DocumentDTO>;
  accountingYear: string;
  accountNumber: number;

  invoiceType: MasterDataDTO;

  plannedPeriod: InvoicePlannedPeriodDTO;
  paymentType: MasterDataDTO;
  paymentInGoods: number;

  parsedFormat: boolean;
  electronicInvoice: boolean;

  correctedInvoiceSerialNumber: string;
  correctedInvoiceNumber: string;
  correctReason: string;

  externalCode: string;
  from: string;
  document: DocumentDTO;
  documentClass: DocumentClassDTO;

  existsGoodsAmount: boolean; // Hay pago en bienes
  rcGenerico: boolean;

  requiresSynchronization: boolean;

  certifiedDigitization: boolean;
}

export class ContractDTO {
  representative: RepresentativeDTO;
  // uuid
  identifier: string;
  class: string;
  task: TaskDTO;

  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  context?: ObjectContextDTO;

  registrationNumber: string;
  localOrganizationalEntity: MasterDataDTO;
  receivedTender: number;
  modalityAmount: MasterDataDTO;
  modalityUnit: string;
  othersContributions: number;
  organizationalUnitAM: OrganizationalUnitDTO;
  organizationalInfo: ContractOrganizationalInfoDTO;
  procurementProjectInfo: ContractProcurementProjectInformationDTO;
  companyDoc: Array<CompanyDocDTO>;
  actualCompanyDoc: CompanyDocDTO;
  plannedPeriod: ContractPlannedPeriodDTO;
  budget: ContractBudgetDTO;
  contractLots: Array<ContractLotDTO>;
  procurementProjectLots: Array<ProcurementProjectLotDTO>;
  contractLotsCpvs: Array<ContractLotCPVDTO>;
  contractTendererLot: Array<ContractTendererLotDTO>;
  contractTendererLotInvited: Array<ContractTendererLotDTO>;
  contractClassificationSchemaLot: Array<ClassificationSchemaLotDTO>;
  contractSpecialConditionsLot: Array<ContractSpecialConditionsLotDTO>;
  warrantyLot: Array<WarrantyLotDTO>;
  contractAwardCriteriaLot: Array<ContractAwardCriteriaLotDTO>;
  totalLots: ContractLotDTO;
  numberAwards: number;
  continuationDossierTracing: boolean;

  // Campos ayto

  administrativeDocument: boolean;
  publicDeed: boolean;
  note: string;
  company: CompanyDTO;
  incomeApplication: string;
  contractClassification: ContractClassificationDTO;

  // Campos replyca
  isProjectReplyca: boolean;
  manualRegistration: boolean;
  areAllowebMultipleOrganizationalUnit: boolean;
  secondBindigAM: MasterDataDTO;
  secondBindigCB: MasterDataDTO;
  originalContractingSystemID: ContractDTO;

  customFields: any;

  // Borrar. Ahora solo para demo
  contratoId: string;
  descripcion: string;
  empresa: string;
  expedienteId: string;
  fechaInicio: Date;
  fechaFin: Date;
  importe: number;
  uuid: string;
  reloadProject: boolean;

  awardsByLot: Array<ContractTendererDTO>;
  // Sistea de homologación
  homologationSystem: HomologationSystemDTO;

  // Datos de adaptaciones
  dataAdap: any;

  previousOrganizationalUnitRegistration: boolean;

  euDirective: MasterDataDTO;

  contractorCountry: MasterDataDTO;

}
export class HomologationSystemDTO {
  approvalDate: Date;
  cpv: CPVDTO;
  creationDate: Date;
  endDate: Date;
  estimatedAmount: number
  expectedEndDate: Date;
  fundsCenter: string;
  homologationContractFolderId: string;
  homologationOrganizational: string;
  homologationTitle: string;
  identifier: number
  lastUpdateDate: Date;
  monthPeriod: number
  procurementProjectType: string;
  profilePublicationDate: Date;
  typeCode: MasterDataDTO; // Tipo de Expediente: EXPEDIENTE.TIPOEXPTE (contractType)
}
export class ContractOrganizationalInfoDTO {
  contractingUnit: OrganizationalUnitDTO;
  contractPromoterUnit: OrganizationalUnitDTO;
  contractingAuthority: InboxDTO;
  centerSectionCode: MasterDataDTO;
}
export class ContractProcurementProjectInformationDTO {
  applicableLegislation: MasterDataDTO;
  organizationalUnit: OrganizationalUnitDTO;
  classification: ProcurementProjectClassificationDTO;
  name: string;
  contracFolderId: string;
  type: MasterDataDTO;
  cpvs: Array<CPVDTO>;
  apportioned: boolean;
  allowIntOffers: boolean;
  abbreviatedTitle: string;
}
export class ContractPlannedPeriodDTO {
  publicationDateDOUE: Date;
  publicationDateBOE: Date;
  publicationDateBuyerProfile: Date;
  publicationDateBOC: Date;
  tenderReceptionPeriodEndDate: Date;
  awardDate: Date;
  formalizationDate: Date;
  startDate: Date;
  endDate: Date;
  initialExecutionPeriod: any;
  finalExecutionPeriod: any;
  approvalAwardDate: Date;
  durationMonth: number;
}

export class RegisterContractModicationProjectInformationDTO {

  applicableLegislation: MasterDataDTO// VersionNormativa el expediente: FICHAEXPTE.VERSIONNORMATIVAID
  abbreviatedTitle; // Titulo Abreviado del Contrato: EXPEDIENTE.ALIAS
  organizationalUnit: OrganizationalUnitDTO; // Organismo
  accountingMotivation: MasterDataDTO;

  static patchDTO(projectInfo: RegisterContractModicationProjectInformationDTO): RegisterContractModicationProjectInformationDTO {
    if (!projectInfo) {
      projectInfo = new RegisterContractModicationProjectInformationDTO();
    }
    return projectInfo;
  }

  contructor() {
    RegisterContractModicationProjectInformationDTO.patchDTO(this);
  }
}


export class ContractModicationProjectInformationDTO {

  applicableLegislation: MasterDataDTO// VersionNormativa el expediente: FICHAEXPTE.VERSIONNORMATIVAID
  organizationalUnit: OrganizationalUnitDTO; // Organismo
  name: string;  // Objeto del Contrato
  contractFolderId: string // ExpedienteID
  abbreviatedTitle; // Titulo Abreviado del Contrato: EXPEDIENTE.ALIAS

  type: MasterDataDTO;  // Tipo de Procedimiento: EXPEDIENTEBASE.TIPO
  awardMethod: MasterDataDTO; // Forma de Adjudicacion: EXPEDIENTE.FADJID
  typeCode: MasterDataDTO; // Tipo de Expediente: EXPEDIENTE.TIPOEXPTE (contractType)
  subTypeCode: MasterDataDTO; // Modalidad del contrato: EXPEDIENTE.MODALIDADEXPTE
  complementarySystem: MasterDataDTO; // Sistema Complementario:EXPEDIENTE.SISTCOMPLEMENTARIO

  descriptionExtension: string; // Descripción de la Prórroga: FICHAEXPTE1.DESCPRORROGA

  obligationSubcontract: boolean;

  unitPrice: Array<UnitPriceDTO>;  // precios unitarios

  apportioned: boolean;

  withoutUnitPrice: boolean;

  static patchDTO(projectInfo: ContractModicationProjectInformationDTO): ContractModicationProjectInformationDTO {
    if (!projectInfo) {
      projectInfo = new ContractModicationProjectInformationDTO();
    }
    if (!projectInfo.unitPrice) {
      projectInfo.unitPrice = [];
    }

    return projectInfo;
  }

  contructor() {
    ContractModicationProjectInformationDTO.patchDTO(this);
  }
}

export class ContractBudgetDTO {
  tenderingAmount: BudgetDTO;
  awardAmount: BudgetDTO;
  updatedAwardAmount: BudgetDTO;
  budgetAccountLines: Array<BudgetAccountLineDTO>;
  budgetAccountLinesContract: Array<BudgetAccountLineDTO>;
  cofinancedFile: boolean;
  finalFinancialGuaranteeAAM: boolean;
  awardCancellationPercentage: number;
}
export class BudgetDTO {
  taxType: MasterDataDTO;
  totalAmount: number;
  estimatedAmount: number;
  amountExcludingTaxes: number;
  totalTaxes: number;
  taxRate: number;
}

export class ContractLotDTO {
  lot: LotDTO;
  type: string;
  cpvs: Array<ContractCPVDTO>;
  cpas: Array<ContractCPADTO>;
  contractTenderers: Array<ContractTendererDTO>;
  contractTenderersInvited: Array<ContractTendererDTO>;
  warranty: ContractWarrantyDTO;
  classificationSchema: Array<ClassificationSchemaDTO>;
  specialExecutionConditions: Array<ContractSpecialConditionsDTO>;
  contractAwardCriteria: Array<ContractAwardCriteriaDTO>;
  identifier: string;
}

export class ContractTendererDTO {
  tenderer: CompanyDTO;
  pyme: boolean;
  pymeType: MasterDataDTO;
}

export class ContractLotCPVDTO {
  contractLot: ContractLotDTO;
  contractCpv: ContractCPVDTO;
  identifier: string;
}

export class ContractTendererLotDTO {
  contractLot: ContractLotDTO;
  tenderer: CompanyDTO;
  pyme: boolean;
  pymeType: MasterDataDTO;
}

export class ClassificationSchemaLotDTO {
  contractLot: ContractLotDTO;
  classification: ClassificationSchemaDTO;
}

export class WarrantyLotDTO {
  contractLot: ContractLotDTO;
  warranty: WarrantyDTO;
}

export class ContractSpecialConditionsLotDTO {
  contractLot: ContractLotDTO;
  specialCondition: ContractSpecialConditionsDTO;
}

export class ContractAwardCriteriaLotDTO {
  contractLot: ContractLotDTO;
  awardCriteria: ContractAwardCriteriaDTO;
}


export class LotDTO {
  lotId: number;
  lotNumber: number;
  description: string;
  province: MasterDataDTO;
  reservedContractType: MasterDataDTO;
  rejectedLot: boolean;
  budget: BudgetDTO;
  // nut: MasterDataDTO;
}
export class ContractCPVDTO {
  cpv: CPVDTO;
  identifier: string;
}

export class ContractCPADTO {
  cpv: CPADTO;
}

export class ContractWarrantyDTO {
  warranties: Array<WarrantyDTO>;
  finalWarranty: number;
  dateConstitutionWarranty: Date;
  complementaryWarranty: boolean;
  specialWarranty: boolean;

}

export class ReservedContractTypeDTO {
  identifier: number;
  name: string;
  outsourcing: boolean;
  contractType: string;
}

export class ContractClassificationDTO {
  harmonizedRegulation: boolean;

  mixedContract: boolean;

  privateContract: boolean;

  reservedContract: boolean;

  reservedContractType: ReservedContractTypeDTO;
  percentageSubcontractedSocialInsertionCompanies: number;
  complementaryOthers: boolean;

  readjustedContract: boolean;
  frameworkAgreement: boolean;
  dataTransferAndProcessing: boolean;
  dataTransfer: boolean;
  dataProcessing: boolean;
  accountingMotivation: MasterDataDTO;

  complementarySystem: MasterDataDTO;
  pyme: boolean;
  pymeType: MasterDataDTO;
}


export class HelpDeskDTO {
  url: string;
  name: string;
  helpType: HelpDeskTypeDTO;
}

export enum HelpDeskTypeDTO {
  QUESTION = 'DUDA',
  IMPROVEMENT = 'MEJORA',
  ERROR = 'ERROR',
  LIST = 'LISTADO'
}

export class SubstitutionDTO extends ContextDTO {
  identifier: string;
  task: TaskDTO;
  links: Link[];
  replacedUser: UserDTO;
  substituteUser: UserDTO;
  cause: string;
  signatureComment: string;
  signatureCommentBBDD: string;
  observation: string;
  createDate: Date;
  initDate: Date;
  endDate: Date;
  enabled: boolean;
  application: string;
  applyInboxes: boolean;
  applyProfiles: boolean;
  exclusiveVisibility: boolean;
  state: string;
  stateTranslation: string;
  type: string;
  typeTranslation: string;
  allTypes: any;
  causes: any;
  types: any;
  causeTranslation: any;
  statesSelect: any;
  profiles: Array<ProfileDTO>;
  userInboxes: Array<InboxDTO>;
  replacedOrganizationUnit: string;
  substituteOrganizationUnit: string;
  configurations: any;
  copy: boolean;
}

export class WarranyDTO {
  description: string;
  identifier: string;
  uuid: string;
  division: DivisionDTO;
  projectLot: LotDTO;
  modality: MasterDataDTO;
  warrantyApplication: ApplicationWarranty;
  amount: number;
  percentage: number;
  deadLine: Date;
  type: MasterDataDTO;
  code: string;
}


export enum ApplicationWarranty {
  LICITACION = 'L',
  ADJUDICACION = 'A',
  NO_APLICA = '-'
}

export class ExportProcessDTO {
  identifier: string;
  name: string;
  creationDate: Date;
  description: string;
  execution: any;
  configuration: ExportProcessConfigurationDTO;
  ownerUser: UserDTO;
  exportResources: ExportProcessResources;
  links: Link[];
  task: TaskDTO;
}

export class ExportProcessResources {
  exportProjectEntities: Array<ExportProjectEntityDTO>;
}

export class ExportProjectEntityDTO {
  exportDocuments: Array<ExportDocumentDTO>;
  exportResult: Array<ExportResultDTO>;
  projectEntity: ProjectEntityDTO;
}

export class ExportDocumentDTO {
  document: DocumentDTO;
  exportResult: ExportDocumentResultDTO;
}

export class ExportDocumentResultDTO {
  exportedDocumentVersions: Array<DocumentVersionDTO>;
  isProcessed: boolean;
  originalDocumentVersion: DocumentVersionDTO;
}

export class ExportResultDTO {
  resultMessages: Array<string>;
}

export class ExportProcessConfigurationDTO {
  documentFileSelectionMode: string;
  exportFormat: string;
  includeCommunicationDocuments: boolean;
  includeOnlyCurrentDocumentVersion: boolean;
  includeOnlyPrincipalDocumentVersions: boolean;
  includeOnlySignedDocuments: boolean;
  includeTemporalDocumentVersion: boolean;
}

export class ExportProcessExecutionDTO {
  progress: number;
}



export class ResourceTypeDTO {
  static PROJECT = 'PROJECT';

}
export class ResourceReferenceDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;

  resourceType: ResourceTypeDTO;
  resourceIdentifier: string;
}

export class SupportSessionDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;

  user: UserDTO;
  startDate: Date;
  endDate: Date;
  project: ProjectEntityDTO;
  relatedSupportCaseId: string;

}

export class DebtInquiriesDTO {
  identifier: string;
  task: TaskDTO;

  sendToAEAT: boolean;
  sendToTGSS: boolean;

  process: MasterDataDTO;

  response: string;
}

export class CompanyProjectDTO {
  identifier: string;
  task: TaskDTO;
  company: CompanyDTO;

  division: DivisionDTO;
  documentClass: DocumentClassDTO;

}

export interface WorkCompanyProjectDTO extends BaseObjectDTO<string> {
  identifier: string;
  companyProject: CompanyProjectDTO;
  context?: ObjectContextDTO;
}

export class CofinancingLineDTO {
  budgetYear: number;
  budgetItem: string;
  budgetAmount: number;
  project: string;
  entity: string;
  entityDescription: string;
}
